export default {
  // ===== COMMON =====
  'common.shopNow': 'এখনই কিনুন',
  'common.whereToBuy': 'কোথায় পাবেন',
  'common.learnMore': 'আরও জানুন',
  'common.readMore': 'আরও পড়ুন',
  'common.subscribe': 'সাবস্ক্রাইব করুন',
  'common.submit': 'জমা দিন',
  'common.download': 'ডাউনলোড করুন',
  'common.verify': 'যাচাই করুন',
  'common.discover': 'আবিষ্কার করুন',
  'common.back': 'ফিরে যান',
  'common.next': 'পরবর্তী',
  'common.close': 'বন্ধ করুন',
  'common.search': 'অনুসন্ধান করুন',
  'common.filter': 'ফিল্টার',
  'common.loading': 'লোড হচ্ছে...',
  'common.freeShipping': 'ফ্রি শিপিং',
  'common.over': 'এর বেশি',
  'common.save': 'সাশ্রয় করুন',
  'common.from': 'থেকে',
  'common.step': 'Step',
  'common.set': 'Set',
  'common.officialStore': 'অফিসিয়াল স্টোর',
  'common.partnerPharmacies': 'পার্টনার ফার্মেসি',
  'common.onlineRetailers': 'অনলাইন রিটেইলার',
  'common.getDirections': 'ডিরেকশন পান',
  'common.call': 'কল করুন',
  'common.hours': 'সময়সূচী',
  'common.address': 'ঠিকানা',
  'common.contact': 'যোগাযোগ',
  'common.apply': 'আবেদন করুন',
  'common.seeAll': 'সব দেখুন',
  'common.viewDetails': 'বিস্তারিত দেখুন',
  'common.addToCart': 'কার্টে যোগ করুন',
  'common.checkout': 'চেকআউট',
  'common.placeOrder': 'অর্ডার করুন',
  'common.continueShopping': 'কেনাকাটা চালিয়ে যান',
  'common.select': 'নির্বাচন করুন',
  'common.submitting': 'জমা দেওয়া হচ্ছে...',
  'common.max': 'সর্বোচ্চ অক্ষর',
  'common.remove': 'সরান',
  'common.decrease': 'কমান',
  'common.increase': 'বাড়ান',
  'common.item': 'পণ্য',
  'common.items': 'পণ্যসমূহ',
  'common.sending': 'পাঠানো হচ্ছে...',
  'common.all': 'সব',

  // ===== NAV =====
  'nav.brandStory': 'ব্র্যান্ড স্টোরি',
  'nav.threeStep': '3-Step ট্রিটমেন্ট',
  'nav.products': 'প্রোডাক্টস',
  'nav.content': 'কন্টেন্ট',
  'nav.whereToBuy': 'কোথায় পাবেন',
  'nav.shop': 'শপ',
  'nav.account': 'অ্যাকাউন্ট',
  'nav.cart': 'কার্ট',

  // ===== FOOTER =====
  'footer.brandDesc': "বাংলাদেশের প্রথম ডার্মোকসমেটিক K-Beauty ব্র্যান্ড। ফার্মাসিস্ট-প্রস্তাবিত ক্লিনিক্যাল উপাদান, কোরিয়ান ইনোভেশন, খাঁটি ফলাফল।",
  'footer.hotlineLabel': 'হটলাইন',
  'footer.hotline': '+৮৮০ ১XXX-XXXXXX',
  'footer.brand': 'ব্র্যান্ড',
  'footer.products': 'প্রোডাক্টস',
  'footer.support': 'সাপোর্ট',
  'footer.brandStory': 'ব্র্যান্ড স্টোরি',
  'footer.threeStepTreatment': '3-Step ট্রিটমেন্ট',
  'footer.ourPhilosophy': 'আমাদের ফিলোসফি',
  'footer.ingredientResearch': 'উপাদান গবেষণা',
  'footer.step01': 'Step 01 — Skin Priming Booster Essence',
  'footer.step02': 'Step 02 — Daily Rescue Serum',
  'footer.step03': 'Step 03 — Barrier Seal Cream',
  'footer.threeStepSet': '3-Step Set',
  'footer.shopAll': 'সব প্রোডাক্ট কিনুন',
  'footer.aboutUs': 'আমাদের সম্পর্কে',
  'footer.contactUs': 'যোগাযোগ করুন',
  'footer.faq': 'FAQ',
  'footer.shippingReturns': 'শিপিং এবং রিটার্নস',
  'footer.privacyPolicy': 'প্রাইভেসি পলিসি',
  'footer.termsOfService': 'টার্মস অফ সার্ভিস',
  'footer.copyright': '© 2026 The.K Seoul Co., Ltd. সর্বস্বত্ব সংরক্ষিত।',
  'footer.dgda': 'DGDA রেজিস্ট্রেশন: প্রক্রিয়াধীন',
  'footer.parentCompany': 'প্যারেন্ট কোম্পানি',
  'footer.marketingAuth': 'Marketing Authorization Holder (化粧品責任판매업자): The.K Seoul Co., Ltd. (Korea)',
  'footer.manufacturer': 'Manufacturer (化粧品製造業者): Jungin Cosmetics Co., Ltd. (Korea)',
  'footer.bdOperations': 'বাংলাদেশ অপারেশনস: Sol Grace Construction BD. Ltd. — Dhaka, Bangladesh',
  'footer.registeredAddress': 'নিবন্ধিত ঠিকানা: Apt-A1, House 94, Park Road, Block-K, Baridhara, Dhaka-1212, Bangladesh',
  'footer.tradeLicense': 'ট্রেড লাইসেন্স নং: TRAD/DNCC/027028/2025',

  // ===== HOME HERO =====
  'home.hero.dailyTreatment': '3-Step ডেইলি ট্রিটমেন্ট',
  'home.hero.prescription': 'স্কিনকেয়ার প্রেসক্রিপশন',
  'home.hero.kBeauty': 'আপনার ত্বকের জন্য, K-Beauty এর পক্ষ থেকে',
  'home.hero.subtitle': 'ফার্মাসিস্ট-প্রস্তাবিত ক্লিনিক্যাল উপাদান। ১০০% আসল হওয়ার গ্যারান্টি। 3-Step ডেইলি ট্রিটমেন্ট।',
  'home.hero.ctaProducts': 'আমাদের প্রোডাক্টস',
  'home.hero.ctaWhereToBuy': 'কোথায় পাবেন',
  'home.hero.statClean': '100% ক্লিন',
  'home.hero.statCleanSub': 'ক্লিনিক্যাল গ্রেড',
  'home.hero.statDerma': 'K+ Derma',
  'home.hero.statDermaSub': 'কোরিয়ান ইনোভেশন',
  'home.hero.statPrescribed': 'Rx প্রেসক্রাইবড',
  'home.hero.statPrescribedSub': 'ফার্মাসিস্ট ভেরিফাইড',
  'home.hero.scroll': 'স্ক্রোল করুন',
  'home.hero.trustBadge1': 'GMP সার্টিফাইড ম্যানুফ্যাকচারিং',
  'home.hero.trustBadge2': 'ফার্মাসিস্ট ভেরিফাইড ফর্মুলা',
  'home.hero.trustBadge3': 'DGDA রেজিস্ট্রেশন প্রক্রিয়াধীন',
  'home.hero.trustBadge4': 'Made in Korea',
  'home.hero.product01': 'Skin Priming Booster Essence',
  'home.hero.product02': 'Daily Rescue Serum',
  'home.hero.product03': 'Barrier Seal Cream',
  'home.hero.statDermaLabel': 'K+ Derma',
  'home.hero.statPrescribedLabel': 'Rx Prescribed',
  'home.hero.ctaShopSet': '3-STEP SET কিনুন — ৳8,000\n(৳500 সেভ করুন)',

  // ===== HOME BRAND STORY =====
  'home.brandStory.label': 'ব্র্যান্ড স্টোরি',
  'home.brandStory.heading': 'যেখানে আপনার ত্বক',
  'home.brandStory.subheading': 'K-Beauty এর দেখা পায়',
  'home.brandStory.body': "Rx.K Seoul এর জন্ম একটি সাধারণ প্রশ্ন থেকে: কার্যকর, ডার্মাটোলজিস্ট-গ্রেড স্কিনকেয়ার কেন সবার হাতের নাগালে থাকবে না? আমরা কোরিয়ান R&D এর শ্রেষ্ঠত্বকে ক্লিনিক্যাল-গ্রেড ফর্মুলার সাথে যুক্ত করেছি — এবং এটিকে দেশের প্রথম ফার্মেসি-কসমেটিক K-Beauty ব্র্যান্ড হিসেবে বাংলাদেশে নিয়ে এসেছি। প্রতিটি উপাদান প্রমাণিত কার্যকারিতার জন্য বেছে নেওয়া হয়েছে। প্রতিটি ধাপ দৃশ্যমান ফলাফলের জন্য প্রেসক্রাইব করা হয়েছে।",
  'home.brandStory.pillar1.title': 'Rx প্রেসক্রিপশন',
  'home.brandStory.pillar1.sub': 'ক্লিনিক্যাল-গ্রেড',
  'home.brandStory.pillar2.title': 'K-Beauty',
  'home.brandStory.pillar2.sub': 'কোরিয়ান ইনোভেশন',
  'home.brandStory.pillar3.title': 'ব্যারিয়ার রিপেয়ার',
  'home.brandStory.pillar3.sub': 'স্কিন প্রোটেকশন',
  'home.brandStory.cta': 'আমাদের গল্প পড়ুন →',
  'home.brandStory.est': 'প্রতিষ্ঠিত',
  'home.brandStory.year': '2026',
  'home.brandStory.seoul': 'Seoul',

  // ===== HOME ROUTINE =====
  'home.routine.label': 'ডেইলি রিচুয়াল',
  'home.routine.heading': '3-Step ডেইলি ট্রিটমেন্ট',
  'home.routine.tagline': 'OPEN · TREAT · LOCK',
  'home.routine.cta': 'সম্পূর্ণ রুটিন গাইড →',

  // ===== HOME LAUNCH GALLERY =====
  'home.launchGallery.eyebrow': 'লঞ্চ শোকেস — K-GOODS FESTA 2026',
  'home.launchGallery.heading': 'যেখানে K-Beauty সরাসরি বাংলাদেশের সাথে মিলিত হলো।',
  'home.launchGallery.subline': 'KOTRA ও বাংলাদেশে কোরিয়া প্রজাতন্ত্রের দূতাবাসের সহ-আয়োজনে · Jamuna Future Park · ১৯-২০ জুন ২০২৬',
  'home.launchGallery.caption.brandPanel': 'Prescribed by Science, Designed for You',
  'home.launchGallery.caption.booth': 'The.K Seoul pavilion, Jamuna Future Park',
  'home.launchGallery.caption.consult': 'Science-first skincare advice',
  'home.launchGallery.caption.crowd': 'A full house at the Rx.K Testing Zone',
  'home.launchGallery.caption.model': 'Live consultation at the VIP Corner',
  'home.launchGallery.caption.model2': 'Discovering the 3-Step Daily Treatment',
  'home.launchGallery.caption.team': 'Bangladesh x Korea — our team at the booth',
  'home.launchGallery.caption.team2': 'Bangladesh x Korea — our team at the booth',
  'home.launchGallery.badge': 'Jamuna TV-তে দেখা হয়েছে',
  'home.launchGallery.cta': '3-Step সেট সম্পর্কে জানুন →',

  // ===== HOME CTA SPLIT =====
  'home.ctaSplit.left.brand': 'Rx+. K SEOUL',
  'home.ctaSplit.left.heading': 'কোরিয়ান ফার্মাসিস্টদের প্রেসক্রাইব করা K-Beauty এর অভিজ্ঞতা নিন',
  'home.ctaSplit.right.heading': 'আজই আপনার রুটিন শুরু করুন',
  'home.ctaSplit.right.body': "বাংলাদেশের সেই হাজারো মানুষের সাথে যোগ দিন যারা ফার্মাসিস্ট-প্রস্তাবিত স্কিনকেয়ারে সুইচ করেছেন। ক্লিনিক্যাল উপাদান, কোরিয়ান ইনোভেশন, খাঁটি ফলাফল — পৌঁছে যাবে আপনার দোরগোড়ায়।",
  'home.ctaSplit.right.step1': '01 OPEN',
  'home.ctaSplit.right.step2': '02 TREAT',
  'home.ctaSplit.right.step3': '03 LOCK',
  'home.ctaSplit.right.ctaShop': 'এখনই কিনুন →',
  'home.ctaSplit.right.ctaWhere': 'কোথায় পাবেন →',
  'home.ctaSplit.stat1.label': 'ফ্রি শিপিং',
  'home.ctaSplit.stat1.value': '৳3,000 এর বেশি',
  'home.ctaSplit.stat2.label': 'মাইলেজ রিওয়ার্ডস',
  'home.ctaSplit.stat2.value': '10% ব্যাক',
  'home.ctaSplit.stat3.label': 'প্রতিটি প্রোডাক্ট',
  'home.ctaSplit.stat3.value': 'QR ভেরিফাইড',

  // ===== HOME ARTICLES =====
  'home.articles.label': 'নলেজ',
  'home.articles.heading': 'স্কিনকেয়ার ইন্টেলিজেন্স',
  'home.articles.cta': 'সব আর্টিকেল →',

  // ===== HOME AUTHENTICITY =====
  'home.authenticity.label': '100% আসল হওয়ার গ্যারান্টি',
  'home.authenticity.subLabel': 'DGDA-নিবন্ধিত ভেরিফিকেশন সিস্টেম',
  'home.authenticity.heading': 'স্ক্যান করুন। যাচাই করুন। বিশ্বাস রাখুন।',
  'home.authenticity.body': 'প্রতিটি Rx.K Seoul বক্সে একটি ইউনিক QR কোড থাকে। অথোরাইজড রিটেইল স্টোর যাচাই করতে স্ক্যান করুন এবং নিশ্চিত করুন যে আপনার প্রোডাক্টটি আসল — সরাসরি কোরিয়ার The.K Seoul Co., Ltd. থেকে আগত।',
  'home.authenticity.cta': 'আপনার প্রোডাক্ট যাচাই করুন',
  'home.authenticity.badge': 'প্রোডাক্টে থাকা QR স্ক্যান করুন',

  // ===== HOME NEWSLETTER =====
  'home.newsletter.heading': 'আপডেটেড থাকুন',
  'home.newsletter.body': 'বাংলাদেশের মার্কেটের জন্য স্কিনকেয়ার টিপস, উপাদান বিজ্ঞান এবং এক্সক্লুসিভ অফার পান।',
  'home.newsletter.placeholder': 'আপনার ইমেইল ঠিকানা দিন',
  'home.newsletter.submit': 'সাবস্ক্রাইব করুন',
  'home.newsletter.success': 'সাবস্ক্রাইব করার জন্য ধন্যবাদ! ওয়েলকাম মেসেজের জন্য আপনার ইনবক্স চেক করুন।',
  'home.newsletter.error': 'অনুগ্রহ করে একটি সঠিক ইমেইল ঠিকানা দিন।',
  'home.newsletter.privacy': 'সাবস্ক্রাইব করার মাধ্যমে, আপনি মার্কেটিং ইমেইল গ্রহণে সম্মত হচ্ছেন। যে কোনো সময় আনসাবস্ক্রাইব করতে পারবেন।',

  // ===== HOME REVIEWS =====
  'home.reviews.label': 'আসল রিভিউ',
  'home.reviews.heading': 'রিভিউ যা নিজেরই কথা বলে',
  'home.reviews.subtext': 'সারা বিশ্বের Rx.K Seoul গ্রাহকদের আসল রিভিউ।',

  // ===== HOME NAVBAR =====
  'home.nav.brandStory': 'ব্র্যান্ড স্টোরি',
  'home.nav.routine': 'রুটিন',
  'home.nav.products': 'প্রোডাক্টস',
  'home.nav.whereToBuy': 'কোথায় পাবেন',
  'home.nav.ourProducts': 'আমাদের প্রোডাক্টস',
  'home.nav.menuOpen': 'মেনু খুলুন',

  // ===== HOME FOOTER =====
  'home.footer.brand': 'ব্র্যান্ড',
  'home.footer.products': 'প্রোডাক্টস',
  'home.footer.contact': 'যোগাযোগ',
  'home.footer.brandStory': 'ব্র্যান্ড স্টোরি',
  'home.footer.philosophy': 'ফিলোসফি',
  'home.footer.ingredientResearch': 'উপাদান গবেষণা',
  'home.footer.sustainability': 'টেকসই উন্নয়ন',
  'home.footer.step01': 'Step 01 — বুস্টার এসেন্স',
  'home.footer.step02': 'Step 02 — ডেইলি রেসকিউ সিরাম',
  'home.footer.step03': 'Step 03 — ব্যারিয়ার সিল ক্রিম',
  'home.footer.routineGuide': 'রুটিন গাইড',
  'home.footer.email': 'hello@rxkseoul.com',
  'home.footer.kakao': 'কাকাও চ্যানেল: @rxkseoul',
  'home.footer.address': 'Seoul, Gangnam-gu',
  'home.footer.whereToBuy': 'কোথায় পাবেন →',
  'home.footer.privacy': 'প্রাইভেসি পলিসি',
  'home.footer.terms': 'টার্মস অফ সার্ভিস',
  'home.footer.madeInKorea': 'কোরিয়া তৈরি',

  // ===== HOME WHERE TO BUY SECTION =====
  'home.whereToBuySection.label': 'ক্রয়',
  'home.whereToBuySection.heading': 'কোথায় পাবেন',
  'home.whereToBuySection.desc': 'অনলাইন ও অফলাইনে উপলব্ধ। Rx.K Seoul-এর সাথে পরিচিত হোন।',
  'home.whereToBuySection.seeAll': 'সব দেখুন',

  // ===== HOME CTA SECTION =====
  'home.ctaSection.left.brandLabel': 'Rx.K Seoul / rxk.thekseou.com',
  'home.ctaSection.left.heading': 'প্রেসক্রাইবড বিউটি অভিজ্ঞতা নিন',
  'home.ctaSection.left.subtitle': '3-Step ডেইলি ডার্মা রিসেট রুটিন',
  'home.ctaSection.right.heading': 'এখনই শুরু করুন',
  'home.ctaSection.right.body': 'Seoul-এর ডার্মাটোলজি ও K-Beauty যাতে মিলিত হয়ে আপনার ত্বককে নতুন করে প্রেসক্রাইব করতে পারে।',
  'home.ctaSection.right.ctaProducts': 'আমাদের প্রোডাক্টস →',
  'home.ctaSection.right.ctaWhereToBuy': 'কোথায় পাবেন →',
  'home.ctaSection.stats.freeShipping': 'ফ্রি শিপিং',
  'home.ctaSection.stats.freeShippingValue': '৳50,000 এর বেশি',
  'home.ctaSection.stats.returns': 'রিটার্নস',
  'home.ctaSection.stats.returnsValue': '৩০ দিনের মধ্যে',
  'home.ctaSection.stats.support': 'সাপোর্ট',
  'home.ctaSection.stats.supportValue': '24/7 কাকাও',

  // ===== BRAND STORY =====
  'brandV2.hero.journey': 'আমাদের গল্প',
  'brandV2.founder.label': 'প্রতিষ্ঠাতার কথা',
  'brandV2.founder.quote': 'যাদের সবচেয়ে বেশি দরকার, তাদের কাছে ফার্মেসি-মানের কোরিয়ান স্কিনকেয়ার পৌঁছে দিতে আমরা The.K Seoul শুরু করেছি, আর নিশ্চিত করতে যে প্রতিটি বক্সই আসল।',
  'brandV2.glance.n1': '3',
  'brandV2.glance.l1': 'এক রুটিনে তিন ধাপ',
  'brandV2.glance.n2': '37+',
  'brandV2.glance.l2': 'ঢাকায় পার্টনার ফার্মেসি',
  'brandV2.glance.n3': '2026',
  'brandV2.glance.l3': 'বাংলাদেশে যাত্রা শুরু',
  'brandV2.glance.n4': '100%',
  'brandV2.glance.l4': 'যাচাইযোগ্য বক্স',
  'brandV2.film.label': 'আমাদের ফিল্ম',
  'brandV2.film.heading': 'Rx.K Seoul,',
  'brandV2.film.headingEm': 'চলমান ছবিতে।',
  'brandV2.film.watch': 'আমাদের ফিল্ম দেখুন',
  'brandV2.founder.message': "কোরিয়ান স্কিনকেয়ার সারা বিশ্বে বিশ্বস্ত, কিন্তু বাংলাদেশে প্রায়ই এটা বিক্রি হয় আসল কিনা তার প্রমাণ ছাড়া, আর আমাদের ত্বকে কী আসলে মানায় সেই পরামর্শ ছাড়া।\nতাই আমরা Rx.K Seoul বানিয়েছি একটা ফার্মেসির মতো করে: উদ্দেশ্য নিয়ে বাছাই করা উপাদানে ছোট একটা রুটিন, কোরিয়ায় তৈরি, প্রতিটা ব্যাচ যাচাই করা, আর প্রতিটা বক্স যাচাইযোগ্য।",
  'brandV2.company.label': "কোম্পানি প্রোফাইল",
  'brandV2.company.heading': "The.K Seoul Co., Ltd.",
  'brandV2.company.f1l': "প্যারেন্ট কোম্পানি",
  'brandV2.company.f1v': "The.K Seoul Co., Ltd., কোরিয়া",
  'brandV2.company.f2l': "হেডকোয়ার্টার",
  'brandV2.company.f2v': "Anyang-si, Gyeonggi-do, কোরিয়া",
  'brandV2.company.f3l': "প্রস্তুতকারক",
  'brandV2.company.f3v': "Jungin Cosmetics Co., Ltd., কোরিয়া",
  'brandV2.company.f4l': "বাংলাদেশ অপারেশন",
  'brandV2.company.f4v': "Sol Grace Construction BD. Ltd., ঢাকা",
  'brandV2.company.f5l': "বাংলাদেশে যাত্রা",
  'brandV2.company.f5v': "জুন ২০২৬ · K-Goods Festa, ঢাকা",
  'brandV2.company.f6l': "ট্রেড লাইসেন্স",
  'brandV2.company.f6v': "TRAD/DNCC/027028/2025",
  'brandV2.company.family': "Rx.K Seoul · Pick.K Seoul · Medi.K Seoul",
  'brandV2.name.label': "ব্র্যান্ড",
  'brandV2.name.heading': "Rx.K Seoul মানে কী",
  'brandV2.name.lead': "তিনটি অংশ, একটি ভাবনা: যত্ন নিয়ে প্রেসক্রাইব করা স্কিনকেয়ার, কোরিয়ায় তৈরি, আপনার ত্বকের জন্য।",
  'brandV2.name.rx.mark': "Rx",
  'brandV2.name.rx.title': "প্রেসক্রিপশন",
  'brandV2.name.rx.text': "ফার্মেসির চিহ্ন, কারণ প্রতিটা ফর্মুলা বাছাই করা হয় নির্দিষ্ট কারণে। আমাদের রুটিনের প্রতিটা উপাদানের একটা কাজ আছে, কার্যকর মাত্রায়।",
  'brandV2.name.k.mark': "K",
  'brandV2.name.k.title': "কোরিয়া",
  'brandV2.name.k.text': "কোরিয়ান R&D দিয়ে তৈরি, কোরিয়ান GMP কারখানায় উৎপাদিত, কোরিয়ান ফার্মেসির মান মেনে।",
  'brandV2.name.seoul.mark': "Seoul",
  'brandV2.name.seoul.title': "আমাদের ঘর",
  'brandV2.name.seoul.text': "যেখানে আমাদের প্যারেন্ট কোম্পানি আর গবেষণা দল, আর যেখান থেকে প্রতিটা ব্যাচ ঢাকার পথে রওনা দেয়।",
  'brandV2.founder.word': "FOUNDER",
  'brandV2.brands.rxk': "ফার্মাসিস্টের বাছাই করা ডার্মোকসমেটিক স্কিনকেয়ার, বাংলাদেশের ত্বকের জন্য কোরিয়ায় তৈরি।",
  'brandV2.brands.pickk': "বাংলাদেশের ক্রিয়েটরদের সাথে কোরিয়ার প্রোডাক্ট যুক্ত করার ইনভাইট-অনলি B2B প্ল্যাটফর্ম।",
  'brandV2.brands.medik': "সিউলে মেডিক্যাল ট্যুরিজম: স্কিন, সার্জারি, ডেন্টাল আর হেলথ চেকআপের পার্টনার ক্লিনিক।",
  'brandV2.brands.here': "আপনি এখানে",
  'brandV2.company.familyLabel': "The.K Seoul পরিবার",
  'brandV2.company.tagLabel': "The.K Seoul",
  'brandV2.company.tag': "বিশ্বস্ত K-কমার্সের গ্লোবাল সেতু",
  'brandV2.company.routeFrom': "গবেষণা ও উৎপাদন",
  'brandV2.company.routeTo': "বাংলাদেশ অপারেশন",
  'brandV2.company.familyHeading': "তিনটি ব্র্যান্ড, আস্থার একই মান",
  'brandV2.name.result': "ফার্মেসির যত্ন, কোরিয়ান মান, হৃদয়ে সিউল",
  'brandV2.manifesto.quote': 'ফার্মেসি আর কসমেটিক্স, এক সাথে। প্রেসক্রাইবড বিউটি।',
  'brandV2.manifesto.text': 'Rx.K Seoul সিউলের একটি ডার্মোকসমেটিক ব্র্যান্ড: ফার্মাসিস্টের বাছাই করা উপাদান, কোরিয়ান উৎপাদন আর একটি ছোট রুটিন, বাংলাদেশের ত্বকের জন্য।',
  'brandV2.journey.label': 'সিউল থেকে আপনার কাছে',
  'brandV2.journey.heading': 'প্রতিটি বক্স,',
  'brandV2.journey.headingEm': 'কারখানা পর্যন্ত ট্র্যাক করা।',
  'brandV2.journey.step1.title': 'সিউলে তৈরি ফর্মুলা',
  'brandV2.journey.step1.text': 'কোরিয়ান R&D থেকে ফার্মাসিস্টের বাছাই করা ফর্মুলা।',
  'brandV2.journey.step2.title': 'GMP কারখানায় তৈরি',
  'brandV2.journey.step2.text': 'কঠোর মান নিয়ন্ত্রণসহ কোরিয়ান কারখানা।',
  'brandV2.journey.step3.title': 'ব্যাচ ট্র্যাক করা',
  'brandV2.journey.step3.text': 'সিউল থেকে ঢাকা পর্যন্ত প্রতিটি ব্যাচ অনুসরণ করা হয়।',
  'brandV2.journey.step4.title': 'প্রতিটি বক্সে QR',
  'brandV2.journey.step4.text': 'রুপালি হলোগ্রাম স্ক্যান করে কয়েক সেকেন্ডে যাচাই করুন।',
  'brandV2.journey.step5.title': 'আপনার দরজায়',
  'brandV2.journey.step5.text': 'শুধু অফিসিয়াল চ্যানেলে। ডেলিভারিতে টাকা দিন।',
  'brandV2.journey.verify': 'আপনার প্রোডাক্ট যাচাই করুন',
  'brandV2.cta.shop': '৩-স্টেপ সেট দেখুন',
  'brandStory.hero.label': 'আমাদের গল্প',
  'brandStory.hero.heading': "যেখানে K-beauty Prescription",
  'brandStory.hero.subheading': 'আপনার ত্বকের দেখা পায়',
  'brandStory.hero.subtitle': "বাংলাদেশের প্রথম ডার্মোকসমেটিক K-Beauty ব্র্যান্ড",
  'brandStory.problem.label': 'সমস্যা',
  'brandStory.problem.heading': 'K-Beauty তে আস্থার অভাব',
  'brandStory.problem.p1': "বাংলাদেশের K-Beauty মার্কেট দ্রুত বড় হচ্ছে — কিন্তু সেই সাথে বাড়ছে সমস্যাও। অনলাইন মার্কেটপ্লেসগুলো নকল প্রোডাক্টে ভরে গেছে, সন্দেহজনক কম দামে বিক্রি হচ্ছে যার আসল কোনো যাচাই নেই। ঢাকা, চট্টগ্রাম এবং সিলেটের ভোক্তারা তাদের কষ্টার্জিত টাকা এমন প্রোডাক্টে খরচ করছেন যা নকল, মেয়াদোত্তীর্ণ বা ক্ষতিকারক হতে পারে।",
  'brandStory.problem.p2': "প্রোডাক্ট আসল হলেও, বেশিরভাগ ভোক্তা জানেন না কোন উপাদান দক্ষিণ এশিয়ার ত্বকের সমস্যার জন্য কার্যকর — গ্রীষ্মমণ্ডলীয় রোদে হাইপারপিগমেন্টেশন, অসম ত্বকের রঙ, আর্দ্রতা এবং দূষণে ব্যারিয়ার ক্ষতি, এবং ঢাকার জলবায়ুতে ব্রণ। তারা ইনফ্লুয়েন্সার যা বলেন তাই কেনেন, ফার্মাসিস্ট যা প্রেসক্রাইব করতেন তা নয়।",
  'brandStory.problem.p3': 'ফলাফল? অপচয়িত টাকা, ক্ষতিগ্রস্ত স্কিন ব্যারিয়ার, এবং সেই বিভাগের প্রতি বাড়তে থাকা অবিশ্বাস যা মানুষকে তাদের ত্বকে আত্মবিশ্বাসী করে তোলার কথা।',
  'brandStory.problem.stat1': '70%+',
  'brandStory.problem.stat1Label': 'অননুমোদিত চ্যানেলে নকলের ঝুঁকি',
  'brandStory.problem.stat2': '0',
  'brandStory.problem.stat2Label': 'স্থানীয় ডার্মোকসমেটিক K-Beauty ব্র্যান্ড',
  'brandStory.problem.stat3': '৳12,000+',
  'brandStory.problem.stat3Label': 'অকার্যকর প্রোডাক্টে বার্ষিক গড় খরচ',
  'brandStory.solution.label': 'আমাদের সমাধান',
  'brandStory.solution.heading': 'Rx.K Seoul — Prescription K-Beauty',
  'brandStory.solution.body': 'Dermocosmetics — যেখানে ফার্মেসি কসমেটিক্সের সাথে মিশে। আমরা ফার্মাসিস্ট-কিউরেটেড উপাদান নির্বাচনকে কোরিয়ান R&D এক্সিলেন্সের সাথে যুক্ত করি, অ্যাক্সেসযোগ্য মূল্যে ক্লিনিক্যাল-গ্রেড ফর্মুলেশন ডেলিভার করি। প্রতিটি প্রোডাক্ট প্রেসক্রাইব করার জন্য ডিজাইন করা: একটি উদ্দেশ্যে বেছে নেওয়া, নিরাপত্তার জন্য পরীক্ষিত, এবং আসল হওয়ার জন্য যাচাই করা।',
  'brandStory.solution.feature1.title': 'Clinical Trust',
  'brandStory.solution.feature1.point1': 'ফার্মাসিস্ট-কিউরেটেড ফর্মুলেশন',
  'brandStory.solution.feature1.point2': 'দক্ষিণ এশিয়ার ত্বকে ডার্মাটোলজিক্যালি পরীক্ষিত',
  'brandStory.solution.feature1.point3': 'কোরিয়ান ফার্মাসিউটিক্যাল ম্যানুফ্যাকচারিং স্ট্যান্ডার্ড',
  'brandStory.solution.feature1.point4': 'ক্লিনিক্যালি ইফেক্টিভ কনসেন্ট্রেশনে অ্যাক্টিভ ইনগ্রেডিয়েন্টস',
  'brandStory.solution.feature2.title': 'Authenticity Guaranteed',
  'brandStory.solution.feature2.point1': 'প্রতিটি প্রোডাক্ট বক্সে ইউনিক QR কোড',
  'brandStory.solution.feature2.point2': 'স্ক্যান করুন — তাৎক্ষণিক অথেন্টিকেশন',
  'brandStory.solution.feature2.point3': 'শুধুমাত্র অফিসিয়াল অথোরাইজড চ্যানেলে বিক্রি',
  'brandStory.solution.feature2.point4': 'Seoul ফ্যাক্টরি থেকে আপনার দরজায় ব্যাচ ট্র্যাকিং',
  'brandStory.solution.feature3.title': 'Simplified Routine',
  'brandStory.solution.feature3.point1': '৩টি ধাপ — কোনো বিভ্রান্তি নয়, 10-Step ভয়াবহতা নয়',
  'brandStory.solution.feature3.point2': "বাংলাদেশের গ্রীষ্মমণ্ডলীয় জলবায়ুর জন্য ডিজাইন করা",
  'brandStory.solution.feature3.point3': 'ঢাকার আর্দ্রতা এবং বর্ষাকালেও কাজ করে',
  'brandStory.solution.feature3.point4': 'মার্কেটিং হাইপ নয়, ইফেক্টিভ কনসেন্ট্রেশন',
  'brandStory.madeFor.label': 'আপনার জন্য ফর্মুলেটেড',
  'brandStory.madeFor.heading': 'দক্ষিণ এশিয়ার ত্বকের জন্য ফর্মুলেটেড',
  'brandStory.madeFor.p1': 'দক্ষিণ এশিয়ার ত্বকের অনন্য বৈশিষ্ট্য রয়েছে যা বেশিরভাগ জেনেরিক K-Beauty ব্র্যান্ড উপেক্ষা করে। উচ্চ মেলানিন কন্টেন্টের কারণে ভিন্ন পিগমেন্টেশন প্যাটার্ন। গ্রীষ্মমণ্ডলীয় আর্দ্রতা হালকা, নন-কমেডোজেনিক টেক্সচার চায়। এবং ধ্রুবক UV ড্যামেজের বিরুদ্ধে লড়াইয়ের জন্য সারফেস-লেভেল ব্রাইটনিংয়ের চেয়ে গভীরে কাজ করা উপাদান প্রয়োজন।',
  'brandStory.madeFor.p2': "আমরা এই সমস্যাগুলোর জন্য বিশেষভাবে Rx.K Seoul রুটিনের প্রতিটি উপাদান নির্বাচন করেছি। Niacinamide 5% সেলুলার লেভেলে হাইপারপিগমেন্টেশন টার্গেট করে। Niacinamide 2% with PHA/LHA ভারী না হওয়ার মধ্যেও মাল্টি-লেয়ার হাইড্রেশন দেয়। Ceramide NP ঢাকার আর্দ্রতা এবং দূষণের কারণে ক্রমাগত ক্ষতিগ্রস্ত ব্যারিয়ার পুনর্নির্মাণ করে।",
  'brandStory.madeFor.cta': '3-Step ট্রিটমেন্ট আবিষ্কার করুন →',
  'brandStory.madeFor.concern1.title': 'গ্রীষ্মমণ্ডলীয় রোদের ক্ষতি',
  'brandStory.madeFor.concern1.desc': 'বছরব্যাপী UV এক্সপোজার থেকে হাইপারপিগমেন্টেশন এবং ডার্ক স্পট',
  'brandStory.madeFor.concern2.title': 'আর্দ্রতা ও দূষণ',
  'brandStory.madeFor.concern2.desc': "ঢাকার শহুরে পরিবেশে ব্যারিয়ার ক্ষতি এবং ক্লগড পোরস",
  'brandStory.madeFor.concern3.title': 'অসম ত্বকের রঙ',
  'brandStory.madeFor.concern3.desc': 'মেলানিন-সমৃদ্ধ ত্বকে সাধারণ পোস্ট-ইনফ্লেমেটরি পিগমেন্টেশন',
  'brandStory.madeFor.concern4.title': 'ব্যারিয়ার সংবেদনশীলতা',
  'brandStory.madeFor.concern4.desc': 'ক্ষতিকর প্রোডাক্ট এবং জলবায়ু স্ট্রেস থেকে ক্ষতিগ্রস্ত স্কিন ব্যারিয়ার',
  'brandStory.company.label': 'আমাদের প্যারেন্ট কোম্পানি',
  'brandStory.company.heading': 'The.K Seoul Co., Ltd. দ্বারা সমর্থিত',
  'brandStory.company.p1': 'The.K Seoul Co., Ltd. একটি কোরিয়ান বিউটি কোম্পানি যা ফার্মাসিউটিক্যাল-গ্রেড স্কিনকেয়ার সেই মার্কেটে নিয়ে আসার মিশন নিয়ে প্রতিষ্ঠিত যেখানে এটি সবচেয়ে বেশি প্রয়োজন। আমাদের Seoul-ভিত্তিক R&D টিম কোরিয়ান ডার্মাটোলজিস্ট এবং ফার্মাসিস্টদের সাথে কাজ করে এমন ফর্মুলেশন তৈরি করে যা কোরিয়ান ফার্মাসিউটিক্যাল স্ট্যান্ডার্ড এবং গ্রীষ্মমণ্ডলীয় জলবায়ুর বিশেষ চাহিদা উভয়ই পূরণ করে।',
  'brandStory.company.p2': 'প্রতিটি ব্যাচ GMP-সার্টিফাইড কোরিয়ান ফ্যাসিলিটিতে ম্যানুফ্যাকচার করা হয়, কঠোর কোয়ালিটি কন্ট্রোলের মধ্য দিয়ে যায়, এবং ফ্যাক্টরি ছাড়ার আগে ডার্মাটোলজিক্যালি টেস্ট করা হয়। আপনি যখন Rx.K Seoul ব্যবহার করেন, আপনি সেই একই স্ট্যান্ডার্ড ব্যবহার করছেন যা কোরিয়ান ফার্মেসিগুলো চায়।',
  'brandStory.company.signatureName': 'Jack Daniel',
  'brandStory.company.signatureCaption': 'Jack Daniel, The.K Seoul Co., Ltd.',
  'brandStory.company.stat1': 'KOREA',
  'brandStory.company.stat1Label': 'Made in Korea',
  'brandStory.company.stat2': 'GMP',
  'brandStory.company.stat2Label': 'GMP Certified',
  'brandStory.company.stat3': 'TESTED',
  'brandStory.company.stat3Label': 'Dermatologically Tested',
  'brandStory.cta.heading': 'প্রেসক্রাইবড বিউটি অভিজ্ঞতা নিন',
  'brandStory.cta.body': "বাংলাদেশের প্রথম prescription K-Beauty ব্যবহারকারী কমিউনিটিতে যোগ দিন। ক্লিনিক্যাল উপাদান, কোরিয়ান ইনোভেশন, খাঁটি ফলাফল — ৳2,500 থেকে শুরু।",
  'brandStory.cta.downloadBrochure': 'ব্রোশিউর ডাউনলোড করুন',

  // ===== 3-STEP TREATMENT =====
  'threeStep.hero.label': 'Daily Ritual',
  'threeStep.hero.heading': '3-Step Daily Treatment',
  'threeStep.hero.subtitle': 'Your daily prescription for beautiful skin. Open · Treat · Lock.',
  'threeStep.philosophy.label': 'The Philosophy',
  'threeStep.philosophy.heading': 'Why 3 Steps?',
  'threeStep.philosophy.p1': "K-Beauty is famous for its elaborate 10-step routines. But here's what dermatologists know: most of those steps are optional. The science of skincare comes down to three essential actions that every skin type needs, every single day.",
  'threeStep.philosophy.prep': 'Prep',
  'threeStep.philosophy.prepDesc': 'replenish water content in the skin barrier.',
  'threeStep.philosophy.treat': 'Treat',
  'threeStep.philosophy.treatDesc': 'deliver active ingredients that target specific concerns.',
  'threeStep.philosophy.seal': 'Seal',
  'threeStep.philosophy.sealDesc': 'seal in the actives and defend against environmental damage.',
  'threeStep.philosophy.p2': 'Rx.K Seoul distills clinical dermatology into a routine anyone can follow — morning and evening, in under 5 minutes. No confusion, no overwhelm, just prescribed results.',
  'threeStep.step01.badge': 'OPEN',
  'threeStep.step01.name': 'Skin Priming Booster Essence',
  'threeStep.step01.subtitle': 'Prep. Brighten. Boost.',
  'threeStep.step01.price': '৳2,500',
  'threeStep.step01.volume': '50ml',
  'threeStep.step01.desc': 'The essential first step. Niacinamide 2% brightens and evens skin tone while PHA/LHA gently exfoliates surface dead cells for a smoother canvas. Hyaluronic Acid delivers multi-layer hydration, and Centella Asiatica calms inflammation and supports healing. Your skin is now primed, brightened, and ready for treatment.',
  'threeStep.step01.ingredientsLabel': 'Key Ingredients',
  'threeStep.step01.howToUse': 'How to Use',
  'threeStep.step01.use1': 'After cleansing, apply to damp skin',
  'threeStep.step01.use2': 'Dispense 2-3 pumps into palms',
  'threeStep.step01.use3': 'Gently pat over face and neck',
  'threeStep.step01.use4': 'Wait 30 seconds before Step 02',
  'threeStep.step01.cta': 'Shop Skin Priming Booster Essence →',
  'threeStep.step02.badge': 'TREAT',
  'threeStep.step02.name': 'Daily Rescue Serum',
  'threeStep.step02.subtitle': 'Repair. Strengthen. Restore.',
  'threeStep.step02.price': '৳2,800',
  'threeStep.step02.volume': '50ml',
  'threeStep.step02.desc': 'The treatment powerhouse. Niacinamide 5% targets dark spots, post-inflammatory hyperpigmentation, and uneven tone at the cellular level. Tranexamic Acid 1-2% clinically reduces melasma and PIH. Peptide accelerates skin repair and boosts collagen. Ceramide NP reinforces the lipid barrier for stronger, more resilient skin.',
  'threeStep.step02.ingredientsLabel': 'Key Ingredients',
  'threeStep.step02.howToUse': 'How to Use',
  'threeStep.step02.use1': 'After Skin Priming Booster Essence fully absorbs',
  'threeStep.step02.use2': 'Press pump once for a single dose',
  'threeStep.step02.use3': 'Apply evenly to face and neck',
  'threeStep.step02.use4': 'Allow 60 seconds of absorption',
  'threeStep.step02.use5': 'Proceed to Step 03 immediately after',
  'threeStep.step02.cta': 'Shop Daily Rescue Serum →',
  'threeStep.step03.badge': 'LOCK',
  'threeStep.step03.name': 'Barrier Seal Cream',
  'threeStep.step03.subtitle': 'Seal. Protect. Maintain.',
  'threeStep.step03.price': '৳3,200',
  'threeStep.step03.volume': '50ml',
  'threeStep.step03.desc': "The protective final step. Ceramide NP rebuilds your skin's lipid barrier — the same barrier that Dhaka's humidity and pollution constantly compromise. Squalane, a non-comedogenic emollient, seals in all the actives from Step 02 without clogging pores. Coco-Caprylate/Caprate delivers silky moisture without heaviness or greasiness.",
  'threeStep.step03.ingredientsLabel': 'Key Ingredients',
  'threeStep.step03.howToUse': 'How to Use',
  'threeStep.step03.use1': 'After serum has fully absorbed (60s)',
  'threeStep.step03.use2': 'Take a pea-sized amount, warm between fingertips',
  'threeStep.step03.use3': 'Press gently into face and neck — do not rub',
  'threeStep.step03.use4': 'Extend to décolletage for extra protection',
  'threeStep.step03.use5': 'Wait 3 minutes before sunscreen or makeup',
  'threeStep.step03.cta': 'Shop Barrier Seal Cream →',
  'threeStep.climate.label': 'Climate Guide',
  'threeStep.climate.heading': "Adapted for Bangladesh's Climate",
  'threeStep.climate.hot.title': 'Hot & Humid',
  'threeStep.climate.hot.subtitle': 'March – October',
  'threeStep.climate.hot.tip1': 'Use a lighter amount of Barrier Seal Cream — skin produces more sebum in humidity',
  'threeStep.climate.hot.tip2': 'Niacinamide 2% and PHA/LHA in Skin Priming Booster Essence draw ambient moisture from humid air for extra radiance',
  'threeStep.climate.hot.tip3': 'Always apply sunscreen after Step 3. UV exposure is highest during these months',
  'threeStep.climate.hot.tip4': 'Store products in a cool, dry place away from direct sunlight',
  'threeStep.climate.hot.tip5': 'If skin feels oily by midday, blot gently — do not over-wash',
  'threeStep.climate.cool.title': 'Cool & Dry',
  'threeStep.climate.cool.subtitle': 'November – February',
  'threeStep.climate.cool.tip1': 'Apply a generous layer of Skin Priming Booster — dry air increases transepidermal water loss',
  'threeStep.climate.cool.tip2': 'Use the full recommended amount of Barrier Seal Cream to lock in moisture overnight',
  'threeStep.climate.cool.tip3': 'Daily Rescue Serum works exceptionally well for overnight repair during cooler nights',
  'threeStep.climate.cool.tip4': 'Consider adding a humidifier in your bedroom for extra environmental hydration',
  'threeStep.climate.cool.tip5': 'Increase Barrier Seal Cream on dry patches (cheeks, around nose)',
  'threeStep.timeline.label': 'Expected Results',
  'threeStep.timeline.heading': 'Results Timeline',
  'threeStep.timeline.m1.period': '3 Days',
  'threeStep.timeline.m1.title': 'Noticeably More Hydrated',
  'threeStep.timeline.m1.desc': 'Your skin feels softer, smoother, and more comfortable. Niacinamide 2% and PHA/LHA begin brightening and smoothing surface texture immediately.',
  'threeStep.timeline.m2.period': '2 Weeks',
  'threeStep.timeline.m2.title': 'Smoother, More Even Texture',
  'threeStep.timeline.m2.desc': 'Pores appear refined. Skin texture is visibly smoother. Niacinamide 5% and Tranexamic Acid begin regulating sebum and fading pigmentation.',
  'threeStep.timeline.m3.period': '4-6 Weeks',
  'threeStep.timeline.m3.title': 'Visible Reduction in Dark Spots',
  'threeStep.timeline.m3.desc': 'Post-inflammatory hyperpigmentation fades. Skin tone is more even and luminous. The Ceramide NP and Squalane barrier is stronger, making skin more resilient.',
  'threeStep.faq.label': 'FAQ',
  'threeStep.faq.heading': 'Common Questions',
  'threeStep.faq.q1': 'Do I need all 3 steps, or can I just use one?',
  'threeStep.faq.a1': 'Each step serves a distinct purpose. Step 01 (Skin Priming Booster Essence) hydrates and preps the skin. Step 02 (Daily Rescue Serum) delivers active treatment ingredients. Step 03 (Barrier Seal Cream) seals everything in and protects. Using all three together creates a synergistic effect where each step enhances the next. However, if you are just starting out, begin with Step 01 and gradually add the others as your skin adjusts.',
  'threeStep.faq.q2': 'How long before I see visible results?',
  'threeStep.faq.a2': 'Hydration improvement is immediate — you will feel the difference after the first application. Texture and tone improvements typically appear within 2 weeks. Dark spot reduction and significant pigmentation fading require 4–6 weeks of consistent use, as Niacinamide works at the cellular level. Individual results vary based on skin condition, climate, and consistency.',
  'threeStep.faq.q3': 'Is this routine suitable for sensitive skin?',
  'threeStep.faq.a3': 'Yes. All three products are formulated without common irritants: no artificial fragrances, no alcohol denat, no essential oils, and no harsh exfoliants. Niacinamide 5% with Tranexamic Acid and Peptide is well-tolerated by most skin types, including sensitive skin. If you are highly reactive, we recommend starting with Step 01 for one week before adding Step 02, then Step 03. Always patch test behind your ear for 48 hours before full-face use.',
  'threeStep.faq.q4': 'Can men use this routine too?',
  'threeStep.faq.a4': 'Absolutely. Skin is skin, regardless of gender. Men often have thicker, oilier skin and larger pores — the Niacinamide in Step 02 is particularly beneficial for regulating excess sebum and refining pore appearance. Many of our early adopters in Dhaka are men who wanted a simple, effective routine without the complexity of traditional K-Beauty.',
  'threeStep.faq.q5': 'What if I already use other products?',
  'threeStep.faq.a5': 'Rx.K Seoul is designed to replace your current core routine. You can continue using sunscreen (essential) and a gentle cleanser. Avoid mixing with other high-concentration actives like Vitamin C, Retinol, or AHAs/BHAs in the same routine — alternate them with our 3-Step Treatment (e.g., use actives on Monday, Rx.K Seoul on Tuesday).',
  'threeStep.cta.heading': 'Get the Complete 3-Step Set',
  'threeStep.cta.price': '৳8,000',
  'threeStep.cta.originalPrice': '৳8,500',
  'threeStep.cta.save': 'Save ৳500',
  'threeStep.cta.desc': 'Skin Priming Booster Essence (50ml) + Daily Rescue Serum (50ml) + Barrier Seal Cream (50ml). Everything you need for your daily prescription.',
  'common.buyNow': 'এখনই অর্ডার করুন',
  'threeStep.buy.setLabel': 'সম্পূর্ণ ৩-স্টেপ সেট',
  'threeStep.buy.giftBox': 'গিফট বক্স সহ',
  'threeStep.buy.cod': 'ক্যাশ অন ডেলিভারি',
  'threeStep.buy.madeInKorea': 'মেড ইন কোরিয়া',

  // ===== PRODUCTS =====
  'products.hero.label': 'Products',
  'products.hero.heading': 'The Prescription Collection',
  'products.hero.subtitle': 'Clinical-grade formulations, pharmacist-curated for Bangladesh.',
  'products.hero.cta': 'Shop the 3-Step Set',
  'products.allProducts': 'All Products',
  'products.categories': 'Categories',
  'products.step01': 'Step 01 — OPEN',
  'products.step02': 'Step 02 — TREAT',
  'products.step03': 'Step 03 — LOCK',
  'products.set': '3-Step Set',
  'products.viewDetails': 'View Details',
  'products.ingredients': 'Key Ingredients',
  'products.howToUse': 'How to Use',
  'products.clinicalClaims': 'Clinical Claims',
  'products.suggestedUse': 'Suggested Use',
  'products.size': 'Size',
  'products.relatedProducts': 'Related Products',
  'products.fullRoutine': 'Full Routine',
  'products.seeAll': 'See All Products',
  'products.clickToZoom': 'Click to zoom',
  'products.sizeGuide': 'Size Guide',
  'products.realSize': 'Real size',
  'products.sizeGuideDesc': 'Actual product size compared to average adult palm for reference.',
  'products.howToUseVideo': 'How to Use — Video Tutorial',
  'products.watchTutorial': 'Watch the application tutorial',
  'products.ingredientScience': 'Ingredient Science',
  'products.inciName': 'INCI Name',
  'products.clinicalEvidence': 'Clinical Evidence',
  'products.benefit': 'Key Benefit',
  'products.clinicalResults': 'Clinical Study Results',
  'products.clinicalSubtitle': 'Based on 8-week clinical study',
  'products.week4': '4 Weeks',
  'products.week8': '8 Weeks',
  'products.clinicalDisclaimer': 'Based on 8-week clinical study, n=42 subjects. Individual results may vary.',
  'products.reviews': 'Reviews',
  'products.verifiedPurchases': 'ভেরিফায়েড ক্রয়',
  'products.filterAll': 'সব',
  'products.filterPhotos': 'শুধু ছবি',
  'products.verified': 'ভেরিফায়েড ক্রয়',
  'products.productFAQ': 'Product Q&A',
  'products.askQuestion': 'এই প্রোডাক্ট সম্পর্কে প্রশ্ন করুন',
  'products.loginToAsk': 'প্রশ্ন করতে লগইন করুন',
  'products.questionPlaceholder': 'এই প্রোডাক্ট সম্পর্কে আপনার কী জানতে চান?',
  'products.submitQuestion': 'প্রশ্ন জমা দিন',
  'products.questionSubmitted': 'ধন্যবাদ! আপনার প্রশ্নের উত্তর My Account → Q&A-তে দেওয়া হবে।',
  'products.questionSubmitError': 'প্রশ্ন জমা দেওয়া যায়নি। আবার চেষ্টা করুন।',
  'products.crossSell': 'Complete Your Routine',
  'products.writeReview': 'রিভিউ লিখুন',
  'products.yourRating': 'আপনার রেটিং',
  'products.yourSkinType': 'আপনার স্কিন টাইপ (ঐচ্ছিক)',
  'products.selectSkinType': 'স্কিন টাইপ নির্বাচন করুন',
  'products.reviewPlaceholder': 'এই প্রোডাক্ট সম্পর্কে আপনার অভিজ্ঞতা শেয়ার করুন…',
  'products.submitReview': 'রিভিউ জমা দিন',
  'products.loginToReview': 'রিভিউ লিখতে লগইন করুন',
  'products.reviewSubmitted': 'ধন্যবাদ! আপনার রিভিউ অনুমোদনের জন্য জমা দেওয়া হয়েছে।',
  'products.reviewSubmitError': 'রিভিউ জমা দেওয়া যায়নি। আবার চেষ্টা করুন।',
  'products.reviewPending': 'আপনার রিভিউ জমা দেওয়া হয়েছে এবং অনুমোদনের অপেক্ষায় আছে।',
  'products.reviewRejected': 'আপনার রিভিউ প্রকাশের জন্য অনুমোদিত হয়নি।',

  // ===== VERIFY =====
  'verify.hero.label': 'Authentication',
  'verify.hero.heading': 'Verify Your Product',
  'verify.hero.subtitle': 'Scan the QR code on your product to confirm authenticity and view batch details.',
  'verify.instruction.title': 'How to Verify',
  'verify.instruction.step1': 'Locate the QR code sticker on your product box.',
  'verify.instruction.step2': 'Scan with any QR reader or camera app.',
  'verify.instruction.step3': 'View batch number, manufacturing date, and authenticity status.',
  'verify.instruction.step4': 'Contact us if verification fails — we guarantee every product.',
  'verify.demo.title': 'Sample Verification Results',
  'verify.demo.product': 'Product',
  'verify.demo.batch': 'Batch',
  'verify.demo.status': 'Status',
  'verify.demo.date': 'Mfg. Date',
  'verify.demo.authentic': 'Authentic',
  'verify.input.label': 'Product Code',
  'verify.input.placeholder': 'e.g. XXXX-XXXX-XXXX',
  'verify.input.button': 'Verify',
  'verify.input.checking': 'Checking…',
  'verify.result.authentic.title': 'Authentic Product',
  'verify.result.authentic.body': 'This code is on file — {{product}} is a genuine Rx.K Seoul product.',
  'verify.result.authentic.firstVerified': 'First verified',
  'verify.result.field.product': 'Product Name',
  'verify.result.field.batch': 'Batch Number',
  'verify.result.field.mfgDate': 'Manufacturing Date',
  'verify.result.field.expiryDate': 'Expiry Date',
  'verify.result.field.firstScan': 'First Scan',
  'verify.result.field.scanCount': 'Number of Scans',
  'verify.result.field.company': 'Company',
  'verify.result.field.companyValue': 'The.K Seoul',
  'verify.result.suspicious.title': 'Scanned Multiple Times',
  'verify.result.suspicious.body': 'This code has already been scanned multiple times. Please contact customer support if you suspect counterfeit.',
  'verify.result.serial.title': 'This Is the Box Serial Number',
  'verify.result.serial.body': '{{code}} is the stock number printed under the barcode — it is not a verification code. To check your product, scan the QR code on the silver hologram sticker (marked “Scan to Verify”) with your phone camera.',
  'verify.result.notfound.title': 'This Is a Fake Product',
  'verify.result.notfound.body': "This code doesn't match any genuine The.K Seoul product in our system — this is a counterfeit item, not a real product from us. Please stop using it immediately and contact our customer support so we can help.",
  'verify.result.error': 'Something went wrong — please try again.',
  'verify.trust.title': 'Why Authenticity Matters',
  'verify.trust.body': 'Counterfeit cosmetics can contain harmful ingredients. Rx.K Seoul guarantees every product through our QR verification system, batch tracking, and authorized sales channels only.',
  'verify.cta': 'Shop with Confidence',

  // ===== WHERE TO BUY =====
  'whereToBuy.hero.label': 'Retailers',
  'whereToBuy.hero.heading': 'Where to Buy',
  'whereToBuy.hero.subtitle': 'Find Rx.K Seoul at authorized pharmacies and online stores across Bangladesh.',
  'whereToBuy.online.title': 'Official Online Store',
  'whereToBuy.online.subtitle': 'Free delivery on orders over ৳3,000. QR-verified authentic products.',
  'whereToBuy.online.cta': 'Shop Now →',
  'whereToBuy.pharmacy.title': 'Authorized Pharmacies',
  'whereToBuy.pharmacy.subtitle': 'Visit our partner pharmacies for in-person consultation and purchase.',
  'whereToBuy.retail.title': 'Retail Partners',
  'whereToBuy.retail.subtitle': 'Select retail locations carrying Rx.K Seoul products.',
  'whereToBuy.map.title': 'Store Locator',
  'whereToBuy.map.subtitle': 'Find the nearest authorized retailer in your area.',
  'whereToBuy.trust.title': '100% Authentic Guarantee',
  'whereToBuy.trust.body': 'All products sold through authorized channels include QR verification and batch tracking. If you suspect a counterfeit, report it immediately.',
  'whereToBuy.filter.all': 'All',
  'whereToBuy.filter.pharmacy': 'Pharmacy',
  'whereToBuy.filter.online': 'Online',
  'whereToBuy.filter.retail': 'Retail',
  'whereToBuy.officialStore': 'Official Online Store',
  'whereToBuy.shopDirect': 'Shop direct from rxk.thekseoul.com',
  'whereToBuy.shopNow': 'Shop Now →',
  'whereToBuy.comingSoon': 'Coming Soon',
  'whereToBuy.mapPlaceholder': 'Map integration coming soon. Below are our key partner areas.',
  'whereToBuy.poweredBy': 'Powered by Google Maps (integration coming soon)',
  'whereToBuy.searchPlaceholder': 'Search by area or pharmacy name',
  'whereToBuy.filterArea': 'Area',
  'whereToBuy.filterType': 'Type',
  'whereToBuy.showingResults': 'Showing {{count}} of {{total}} stores',
  'whereToBuy.partnerApply': 'Become a Partner',
  'whereToBuy.partnerApplyDesc': 'Interested in carrying Rx.K Seoul at your pharmacy or retail location?',
  'whereToBuy.applyNow': 'Apply Now →',
  'whereToBuy.authenticityGuaranteed': '✓ Authenticity Guaranteed',
  'whereToBuy.qrVerify': 'Scan QR on product box to verify authenticity instantly.',
  'whereToBuy.morePartners.title': 'More Partners Coming Soon',
  'whereToBuy.morePartners.desc': 'Authorized pharmacy partners are being onboarded across Bangladesh',
  'whereToBuy.morePartners.cta': 'Apply to Become a Partner →',
  'whereToBuy.authorizedPartners.heading': 'অনুমোদিত ফার্মেসি পার্টনার — জুন ২০২৬-এর শেষে আসছে',
  'whereToBuy.authorizedPartners.description':
    'আমরা ঢাকা, চট্টগ্রাম এবং সিলেটজুড়ে পার্টনার ফার্মেসি যুক্ত করছি। অনুমোদিত রিটেইলারদের সম্পূর্ণ তালিকা ২০২৬ সালের জুন মাসের শেষে প্রকাশ করা হবে, যাতে ১ জুলাই ২০২৬-এ আমাদের বাংলাদেশে অফিসিয়াল লঞ্চের সময় এটি প্রস্তুত থাকে। ফার্মেসি পার্টনার হিসেবে আগ্রহ প্রকাশ করতে নিচে আবেদন করুন।',
  'whereToBuy.authorizedPartners.button': 'পার্টনার হতে আবেদন করুন →',
  'whereToBuy.showingOne': 'Showing 1 store',
  'whereToBuy.reportCounterfeit': 'Spotted a suspicious product? Report a counterfeit here.',
  'whereToBuy.reportLink': 'Submit a report →',

  // ===== CONTENT =====
  'content.hero.label': 'Knowledge',
  'content.hero.heading': 'Skincare Intelligence',
  'content.hero.subtitle': 'আমাদের ফার্মাসিস্ট ও গবেষকদের কাছ থেকে প্রমাণ-ভিত্তিক স্কিনকেয়ার জ্ঞান।',
  'content.categories': 'Categories',
  'content.allArticles': 'All Articles',
  'content.readTime': 'min read',
  'content.author': 'By',
  'content.published': 'Published',
  'content.relatedArticles': 'Related Articles',
  'content.backToHub': 'Back to Content Hub',

  // ===== ABOUT =====
  'about.hero.label': 'About',
  'about.hero.heading': 'About Rx.K Seoul',
  'about.hero.subtitle': 'Bridging Korean pharmaceutical expertise with Bangladeshi skincare needs since 2026.',
  'about.mission.label': 'Our Mission',
  'about.mission.heading': 'Beauty, Prescribed.',
  'about.mission.body': 'We believe effective skincare should not be a luxury or a gamble. Every Rx.K Seoul product is developed with the rigor of pharmaceutical science and the elegance of Korean beauty innovation.',
  'about.values.label': 'Our Values',
  'about.values.heading': 'What We Stand For',
  'about.story.heading': 'Our Story',
  'about.story.p1': 'The.K Seoul Co., Ltd. is a Seoul-based dermocosmetic company founded with a singular mission: to bring prescription-grade Korean skincare to markets that have been underserved by authentic, clinically tested products.',
  'about.story.p2': 'Rx.K Seoul represents our flagship brand — the first dermocosmetic line developed specifically for Bangladesh, combining Korean pharmaceutical R&D with formulations adapted for tropical climates and common South Asian skin concerns.',
  'about.values.pillar1.title': 'Pharmacist-Led',
  'about.values.pillar1.desc': 'Every formulation is developed and reviewed by licensed pharmacists, not marketers.',
  'about.values.pillar2.title': 'Clinical Concentrations',
  'about.values.pillar2.desc': 'Active ingredients at percentages proven effective in peer-reviewed dermatology research.',
  'about.values.pillar3.title': 'Full Traceability',
  'about.values.pillar3.desc': 'Every product carries a unique verification code. Scan to confirm authenticity instantly.',
  'about.company.heading': 'Company Information',
  'about.company.siteDesc': 'Rx.K Seoul (rxk.thekseoul.com) is an e-commerce website operated for the online sale of The.K Seoul dermocosmetic skincare products in Bangladesh.',
  'about.company.concern': 'The.K Seoul is a business concern of Sol Grace Construction BD. Ltd.',
  'about.company.entity': 'Sol Grace Construction BD. Ltd.',
  'about.company.bin': 'BIN: 009212412-0108',
  'about.company.tin': 'TIN: 520132321674',
  'about.company.address': 'Address: 2/2-A, South Begunbari, Tejgaon I/A, Dhaka-1208, Bangladesh',
  'about.company.tradeLicense': 'Trade License: TRAD/DNCC/027028/2025',

  // ===== CONTACT =====
  'contact.hero.label': 'Contact',
  'contact.hero.heading': "We're here to help",
  'contact.hero.subtitle': "Reach Rx.K Seoul's Dhaka office and Korean headquarters.",
  'contact.form.name': 'Name',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Phone',
  'contact.form.subject': 'Subject',
  'contact.form.message': 'Message',
  'contact.form.submit': 'Send Inquiry',
  'contact.form.success': 'Thank you! We will get back to you within 24 hours.',
  'contact.info.title': 'Contact Information',
  'contact.info.email': 'Email',
  'contact.info.phone': 'Phone',
  'contact.info.address': 'Address',
  'contact.info.hours': 'Business Hours',
  'contact.channels.email.label': 'Email',
  'contact.channels.email.value': 'hello@thekseoul.com',
  'contact.channels.email.note': 'Placeholder — official email coming soon',
  'contact.channels.whatsapp.label': 'WhatsApp / Phone (BD)',
  'contact.channels.whatsapp.value': '+880 1331-661166',
  'contact.channels.whatsapp.note': 'Mon–Sat, 10:00–19:00 BST',
  'contact.channels.hq.label': 'Korea Headquarters',
  'contact.channels.hq.value': 'The.K Seoul Co., Ltd.',
  'contact.channels.hq.note': 'Anyang-si, Gyeonggi-do, South Korea',
  'contact.sendMessage.heading': 'Send a Message',
  'contact.form.namePlaceholder': 'Your full name',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.phoneHelper': '+880 prefix optional',
  'contact.form.subjectPlaceholder': 'Select a topic',
  'contact.form.subjectProductInquiry': 'Product Inquiry',
  'contact.form.subjectPharmacyPartnership': 'Pharmacy Partnership',
  'contact.form.subjectInfluencer': 'Influencer Collaboration',
  'contact.form.subjectMediK': 'Medi.K Seoul Medical Tourism Inquiry',
  'contact.form.subjectPickK': 'Pick.K Seoul Influencer Program',
  'contact.form.subjectCounterfeit': 'Counterfeit Report',
  'contact.form.subjectOther': 'Other',
  'contact.form.messagePlaceholder': 'How can we help you?',
  'contact.form.maxChars': 'Maximum 500 characters',
  'contact.form.messageMinError': 'Message must be at least 20 characters.',
  'contact.form.consent': 'I agree to be contacted by Rx.K Seoul about my inquiry.',
  'contact.form.sending': 'Sending...',
  'contact.form.sendAnother': 'Send Another',
  'contact.success.heading': 'Message Sent',
  'contact.success.body': 'Thank you for reaching out. We will get back to you within 24 hours.',
  'contact.success.toast': 'Thank you. We will respond within 2 business days.',
  'contact.offices.bd.title': 'Bangladesh Operations',
  'contact.offices.bd.company': 'Sol Grace Construction BD. Ltd.',
  'contact.offices.bd.address': 'Apt-A1, House 94, Park Road, Block-K, Baridhara, Dhaka-1212, Bangladesh',
  'contact.offices.korea.title': 'Korea Headquarters',
  'contact.offices.korea.company': 'The.K Seoul Co., Ltd.',
  'contact.offices.korea.address': 'Anyang-si, Gyeonggi-do, South Korea (precise address TBD)',

  // ===== FAQ =====
  'faq.hero.label': 'Support',
  'faq.hero.heading': 'Frequently Asked Questions',
  'faq.hero.subtitle': 'Answers from our pharmacist team.',
  'faq.groupA.title': 'Product Usage',
  'faq.groupB.title': 'Authenticity & Verification',
  'faq.groupC.title': 'Shipping & Returns',
  'faq.groupD.title': 'Pharmacy Partnership',
  'faq.groupA.q1.question': 'How long until I see results?',
  'faq.groupA.q1.answer': 'First hydration improvements: ~3 days. Smoother texture: ~2 weeks. Visible reduction in dark spots: 4–6 weeks. Consistency matters more than quantity.',
  'faq.groupA.q2.question': 'Can I use Rx.K Seoul with my existing skincare?',
  'faq.groupA.q2.answer': 'Yes. The 3-Step routine replaces toner / essence / serum / moisturizer in most regimens. Continue using sunscreen separately (SPF 30+ daily).',
  'faq.groupA.q3.question': 'Is the routine safe during pregnancy?',
  'faq.groupA.q3.answer': 'All three products avoid retinoids and high-percentage actives flagged as pregnancy-cautious. Consult your obstetrician before adding any new skincare during pregnancy.',
  'faq.groupA.q4.question': 'Can men use Rx.K Seoul?',
  'faq.groupA.q4.answer': 'Yes. The formulas are dermatologically tested and non-comedogenic, suitable for all adult skin.',
  'faq.groupA.q5.question': 'How much product per application?',
  'faq.groupA.q5.answer': 'Booster: 2–3 pumps. Serum: 1 pump. Cream: pea-sized.',
  'faq.groupB.q1.question': 'How do I verify my product is genuine?',
  'faq.groupB.q1.answer': 'Every Rx.K Seoul box has a unique QR code on the back. Scan it on the /verify page to see batch number, manufacturing date, and authorized retailer. If verification fails, contact us immediately.',
  'faq.groupB.q2.question': 'I bought online and the QR does not work — what should I do?',
  'faq.groupB.q2.answer': 'Submit a counterfeit report on the /contact page with the seller name, purchase date, and a photo of the box and QR. We investigate every report within 48 hours.',
  'faq.groupB.q3.question': 'Where are the safest places to buy Rx.K Seoul?',
  'faq.groupB.q3.answer': 'Our official online store and the authorized pharmacy partners listed on the /buy page. On online marketplaces (Daraz Mall and similar), only buy when the seller is "The.K Seoul Co., Ltd." or an authorized partner.',
  'faq.groupC.q1.question': 'How long does delivery take?',
  'faq.groupC.q1.answer': 'Dhaka: 1–2 business days. Other Bangladesh cities: 2–4 business days.',
  'faq.groupC.q2.question': 'Is shipping free?',
  'faq.groupC.q2.answer': 'Yes, on orders over ৳3,000. Below ৳3,000, a flat ৳120 fee applies.',
  'faq.groupC.q3.question': 'Can I return a product?',
  'faq.groupC.q3.answer': 'Unopened products can be returned within 7 days of delivery. Opened skincare cannot be returned for hygiene reasons unless defective. Contact us for assistance.',
  'faq.groupC.q4.question': 'How do mileage rewards work?',
  'faq.groupC.q4.answer': 'Earn 10% back as Rx.K Points on every order. Redeem at checkout (1 Point = ৳1).',
  'faq.groupD.q1.question': 'How do I become an authorized retailer?',
  'faq.groupD.q1.answer': 'Apply at /partner-apply. Our Country Sales Director (Selim Reza) will respond within 5 business days with margin terms, POSM support, and initial order details.',
  'faq.groupD.q2.question': 'What margins do partners earn?',
  'faq.groupD.q2.answer': 'Standard pharmacy margin terms apply, with additional point-of-sale push incentives. Details shared during the partnership conversation.',
  'faq.groupD.q3.question': 'Do you provide point-of-sale materials?',
  'faq.groupD.q3.answer': 'Yes — counter displays, sample sachets, pharmacist training brochures, and ingredient reference cards.',
  'faq.bottom.title': 'Still have questions?',
  'faq.bottom.body': 'Our support team is ready to help. Reach out any time.',
  'faq.bottom.cta': 'Contact Support →',

  // ===== SHIPPING & RETURNS =====
  'shipping.hero.label': 'Policy',
  'shipping.hero.heading': 'Shipping & Returns',
  'shipping.hero.subtitle': 'Fast, reliable delivery across Bangladesh with hassle-free returns.',
  'shipping.dhaka.title': 'Dhaka Delivery',
  'shipping.dhaka.desc': 'Standard delivery. Delivery charge {{price}}.',
  'shipping.dhaka.time': '5 Business Days',
  'shipping.outside.title': 'Outside Dhaka',
  'shipping.outside.desc': 'Standard delivery. Delivery charge {{price}}.',
  'shipping.outside.time': '10 Business Days',
  'shipping.free.title': 'Free Shipping',
  'shipping.free.desc': 'Free delivery on all orders over {{threshold}}.',
  'shipping.returns.title': 'Return Policy',
  'shipping.returns.desc': 'Unopened products may be returned within 14 days of delivery. opened products are not eligible for return due to hygiene reasons.',
  'shipping.track.title': 'Order Tracking',
  'shipping.track.desc': 'All orders include tracking via SMS and email updates.',
  'shipping.options.heading': 'Shipping Options',
  'shipping.returns.heading': 'Return, Refund & Cancellation Policy',
  'shipping.returns.desc': 'We want you to be completely satisfied with your purchase. If you are not, our return process is simple and straightforward.',
  'shipping.step1.title': 'Request Return',
  'shipping.step1.desc': 'Email us at support@rxkseoul.com within 7 days of delivery with your order number.',
  'shipping.step2.title': 'Ship It Back',
  'shipping.step2.desc': 'Pack the unused, sealed product in its original packaging. We will provide a return label.',
  'shipping.step3.title': 'Get Refunded',
  'shipping.step3.desc': 'Once we receive and inspect the item, your refund is processed within 7–10 working days.',
  'shipping.conditions.heading': 'Return Conditions',
  'shipping.condition1': 'পণ্য অবশ্যই ব্যবহৃত না, খোলা না এবং মূল প্যাকেজিংয়ে সমস্ত সিল অক্ষত থাকতে হবে।',
  'shipping.condition2': 'Return request must be submitted within 7 days of delivery.',
  'shipping.condition3': 'Original order number and verification code must be provided.',
  'shipping.condition4': 'Opened, used, or damaged products (unless defective) are not eligible for return.',
  'shipping.condition5': 'Products purchased from unauthorized retailers are not eligible for returns or warranty.',
  'shipping.refundTimeline.heading': 'Refund Timeline',
  'shipping.refundTimeline.desc': 'Once your returned item is received and inspected, approved refunds are issued within 7–10 working days to your original payment method (or via bKash/bank transfer for Cash on Delivery orders). You will receive an email confirmation once your refund has been processed.',
  'shipping.cancellation.heading': 'Order Cancellation',
  'shipping.cancellation.desc': 'You may cancel your order free of charge at any time before it has been dispatched, by contacting support@rxkseoul.com or WhatsApp with your order number. Once an order has been dispatched for delivery, it can no longer be cancelled — our standard Return Policy above applies instead after delivery.',

  // ===== PRIVACY POLICY =====
  'privacy.hero.label': 'Legal',
  'privacy.hero.heading': 'Privacy Policy',
  'privacy.lastUpdated': 'Last updated: May 2026',
  'privacy.section1.title': '1. Introduction',
  'privacy.section1.body': 'The.K Seoul Co., Ltd. ("we," "us," or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, store, and protect your information when you use the Rx.K Seoul website, products, and services.',
  'privacy.section2.title': '2. Information We Collect',
  'privacy.section2.body': `We may collect the following types of information:

• Personal Information: Name, email address, phone number, shipping address, and billing information provided during purchase or account registration.
• Order Information: Product selections, purchase history, verification codes scanned, and transaction details.
• Technical Information: IP address, browser type, device information, and cookies for website functionality and analytics.
• Communication Data: Messages, inquiries, and feedback submitted through our contact forms or support channels.`,
  'privacy.section3.title': '3. How We Use Your Information',
  'privacy.section3.body': `Your information is used for the following purposes:

• Processing and fulfilling your orders, including shipping and delivery.
• Product authenticity verification and anti-counterfeit tracking.
• Customer support, responding to inquiries, and resolving issues.
• Sending order confirmations, shipping updates, and important product information.
• Improving our website, products, and services based on usage analytics.`,
  'privacy.section4.title': '4. Data Storage and Security',
  'privacy.section4.body': 'We store your data on secure servers provided by Supabase, which uses industry-standard encryption and security protocols. Your personal information is never sold, rented, or shared with third parties for marketing purposes. We retain your data only as long as necessary for the purposes outlined in this policy or as required by applicable law.',
  'privacy.section5.title': '5. Your Rights',
  'privacy.section5.body': `You have the right to:

• Access, update, or correct your personal information.
• Request deletion of your personal data, subject to legal retention requirements.
• Opt out of marketing communications at any time.
• Lodge a complaint with a data protection authority if you believe your rights have been violated.`,
  'privacy.section6.title': '6. Contact Us',
  'privacy.section6.body': 'For questions or concerns about this Privacy Policy, please contact us at support@rxkseoul.com.',

  // ===== TERMS OF SERVICE =====
  'terms.hero.label': 'Legal',
  'terms.hero.heading': 'Terms of Service',
  'terms.lastUpdated': 'Last updated: May 2026',
  'terms.section1.title': '1. Acceptance of Terms',
  'terms.section1.body': 'By accessing or using the Rx.K Seoul website, products, or services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services. We reserve the right to update or modify these terms at any time, and continued use constitutes acceptance of the revised terms.',
  'terms.section2.title': '2. Products and Purchases',
  'terms.section2.body': `All product descriptions, pricing, and availability are subject to change without notice. We make every effort to display accurate colors and details, but actual product appearance may vary slightly due to screen settings. Prices are listed in Bangladeshi Taka (৳) and include applicable taxes unless stated otherwise.

We reserve the right to refuse or cancel any order for reasons including but not limited to product availability, errors in product or pricing information, or suspected fraudulent activity.`,
  'terms.section3.title': '3. Authenticity Verification',
  'terms.section3.body': 'Every Rx.K Seoul product is sold with a unique verification code. This code is intended for single-use verification by the original purchaser. Attempts to reproduce, duplicate, or tamper with verification codes may result in legal action. Products purchased from unauthorized retailers may not be eligible for verification, warranty, or support services.',
  'terms.section4.title': '4. Shipping and Delivery',
  'terms.section4.body': `We ship to addresses within Bangladesh and select international destinations. Standard delivery takes 5 business days inside Dhaka and 10 business days outside Dhaka; these are estimates and not guaranteed. Risk of loss and title for items pass to you upon delivery to the carrier. We are not responsible for delays caused by customs, weather, or other circumstances beyond our control.

Free shipping is available on orders over ৳3,000 within Bangladesh. Standard shipping rates apply to all other orders as displayed at checkout.`,
  'terms.section5.title': '5. Returns, Refunds, and Cancellations',
  'terms.section5.body': `Unused and sealed products may be returned within 7 days of delivery for a full refund. Products must be in their original packaging with all seals and verification codes intact. Used, opened, or damaged products are not eligible for return unless defective. Once we receive and inspect the returned item, approved refunds are issued within 7–10 working days to your original payment method (or via bKash/bank transfer for Cash on Delivery orders).

Orders may be cancelled free of charge at any time before dispatch by contacting support@rxkseoul.com with your order number. Orders that have already been dispatched cannot be cancelled and are instead subject to the return process described above.`,
  'terms.section6.title': '6. Intellectual Property',
  'terms.section6.body': 'All content on this website, including but not limited to text, graphics, logos, images, product descriptions, and software, is the property of The.K Seoul Co., Ltd. or its licensors and is protected by copyright, trademark, and other intellectual property laws. Unauthorized use, reproduction, or distribution is strictly prohibited.',
  'terms.section7.title': '7. Limitation of Liability',
  'terms.section7.body': 'To the maximum extent permitted by law, The.K Seoul Co., Ltd. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our products or services. Our total liability shall not exceed the amount you paid for the specific product or service giving rise to the claim.',
  'terms.section8.title': '8. Third-Party Advertising and Data Sharing',
  'terms.section8.body': 'We do not permit third-party advertisements on this website. We do not sell or share your personal information with third parties for their own marketing purposes. Any integration with a third-party service (such as a payment gateway or delivery courier) is limited to what is necessary to fulfill your order, and that third party is separately responsible for how it handles data you provide directly to it.',
  'terms.section9.title': '9. Governing Law',
  'terms.section9.body': 'These Terms of Service shall be governed by and construed in accordance with the laws of the Republic of Korea. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts of Seoul, South Korea.',
  'terms.section10.title': '10. Contact',
  'terms.section10.body': 'For questions about these Terms of Service, please contact us at support@rxkseoul.com.',

  // ===== CART / CHECKOUT / ORDER =====
  'cart.yourCart': 'Your Cart',
  'cart.empty': 'Your cart is empty',
  'cart.removed': 'Removed from cart',
  'cart.added': 'Added to Cart ✓',
  'cart.viewCart': 'View Cart →',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Shipping',
  'cart.shippingCalculated': 'Calculated at checkout',
  'cart.free': 'Free',
  'cart.total': 'Total',
  'checkout.title': 'Checkout',
  'checkout.contact': 'Contact Information',
  'checkout.contactShipping': 'Contact & Shipping',
  'checkout.fullName': 'Full Name',
  'checkout.phone': 'Phone',
  'checkout.email': 'Email (Optional)',
  'checkout.shipping': 'Shipping Address',
  'checkout.address1': 'Full Address',
  'checkout.address2': 'Address Line 2 (Optional)',
  'checkout.selectDistrict': 'Select District',
  'checkout.selectThana': 'Select Thana',
  'checkout.searchDistrict': 'Search district…',
  'checkout.searchThana': 'Search thana…',
  'checkout.postalCode': 'Postal Code (Optional)',
  'checkout.deliveryNote': 'Delivery Note',
  'checkout.addDeliveryNote': 'Add a delivery note',
  'checkout.deliveryNotePlaceholder': 'Any special instructions for delivery (optional)',
  'checkout.payment': 'Payment Method',
  'checkout.cod': 'Cash on Delivery',
  'checkout.comingSoon': 'Coming Soon',
  'checkout.orderSummary': 'Order Summary',
  'checkout.agreePrefix': 'আমি পড়েছি এবং সম্মত',
  'checkout.termsLink': 'শর্তাবলী',
  'checkout.privacyLink': 'গোপনীয়তা নীতি',
  'checkout.agreeAnd': 'এবং',
  'checkout.returnsLink': 'রিটার্ন ও রিফান্ড নীতি',
  'checkout.freeShippingNote': 'Free shipping on orders over ৳{{threshold}}',
  'checkout.haveCoupon': 'কুপন কোড আছে?',
  'checkout.couponPlaceholder': 'কোড লিখুন',
  'checkout.apply': 'প্রয়োগ করুন',
  'checkout.remove': 'সরান',
  'checkout.discount': 'ছাড়',
  'checkout.comboDiscount': 'কম্বো ছাড়',
  'checkout.giftBox': 'গিফট বক্স যোগ করুন',
  'checkout.giftBoxIncluded': 'গিফট বক্স সহ',
  'checkout.couponApplied': 'কুপন প্রয়োগ হয়েছে',
  'checkout.authenticityGuaranteed': 'Authenticity Guaranteed',
  'checkout.secureCheckout': 'Secure Checkout',
  'order.thankYou': 'Thank you for your order!',
  'order.orderId': 'Order ID',
  'order.estimatedDelivery': 'Estimated delivery',
  'order.businessDays': 'business days',
  'order.outsideDhaka': 'Outside Dhaka',
  'order.orderDetails': 'Order Details',
  'order.notFound': 'Order not found',
  'order.authenticityGuaranteed': 'Authenticity Guaranteed',
  'order.verifyQR': 'Verify with QR',
  'order.invoice': 'ইনভয়েস',
  'order.invoiceFrom': 'প্রেরক',
  'order.invoiceTo': 'প্রাপক',
  'order.description': 'বিবরণ',
  'order.qty': 'পরিমাণ',
  'order.unitPrice': 'একক মূল্য',
  'order.amount': 'পরিমাণ (টাকা)',
  'order.tax': 'ট্যাক্স',
  'order.paymentTerms': 'পেমেন্ট শর্তাবলী',
  'order.notes': 'নোট',
  'stickyBar.product': '3-Step Daily Treatment Set',
  'stickyBar.save': '(Save ৳500)',
  'checkout.guestModal.title': 'How would you like to checkout?',
  'checkout.guestModal.subtitle': 'Sign in for a faster experience and mileage rewards',
  'checkout.guestModal.continue': 'Continue as Guest',
  'checkout.guestNoMileage': 'Mileage rewards are not available for guest checkout',
  'checkout.earnMileage': 'You will earn',

  // ===== CHECKOUT — order submission (Control Core) =====
  'checkout.placing': 'আপনার অর্ডার জমা হচ্ছে...',
  'checkout.error.insufficientStock': 'দুঃখিত, একটি বা একাধিক পণ্যের স্টক শেষ হয়ে গেছে। কার্ট ঠিক করে আবার চেষ্টা করুন।',
  'checkout.error.codBlocked': 'এই নম্বরের জন্য ক্যাশ অন ডেলিভারি এখন উপলব্ধ নেই। চালিয়ে যেতে অনলাইনে পেমেন্ট করুন — নিচে আপনার জন্য একটি অনলাইন অপশন বেছে দেওয়া হয়েছে।',
  'checkout.error.network': 'সার্ভারে পৌঁছানো যায়নি। সংযোগ পরীক্ষা করে আবার চেষ্টা করুন।',
  'checkout.error.server': 'অর্ডার জমা দেওয়ার সময় সমস্যা হয়েছে। একটু পরে আবার চেষ্টা করুন।',
  'checkout.error.validation': 'এই অর্ডারটি প্রক্রিয়া করা যায়নি। তথ্য যাচাই করে আবার চেষ্টা করুন।',
  'checkout.error.config': 'অর্ডার নেওয়া সাময়িকভাবে বন্ধ আছে। পরে আবার চেষ্টা করুন।',

  // ===== AUTH =====
  'auth.login.title': 'Sign In',
  'auth.login.subtitle': 'Welcome back to Rx.K Seoul',
  'auth.login.email': 'Email',
  'auth.login.password': 'Password',
  'auth.login.remember': 'Keep me signed in',
  'auth.login.forgot': 'Forgot password?',
  'auth.login.submit': 'Sign In',
  'auth.login.orSocial': 'or continue with',
  'auth.login.comingSoon': 'coming soon',
  'auth.login.noAccount': "Don't have an account?",
  'auth.login.registerLink': 'Sign up',
  'auth.login.success': 'Welcome back!',
  'auth.login.error': 'Invalid email or password',
  'auth.register.title': 'Create Account',
  'auth.register.subtitle': 'Join Rx.K Seoul for exclusive benefits',
  'auth.register.email': 'Email',
  'auth.register.name': 'Full Name',
  'auth.register.phone': 'Phone Number',
  'auth.register.password': 'Password',
  'auth.register.confirmPassword': 'Confirm Password',
  'auth.register.terms': 'I agree to the Terms of Service (required)',
  'auth.register.privacy': 'I agree to the Privacy Policy (required)',
  'auth.register.marketing': 'I want to receive marketing emails and SMS (optional)',
  'auth.register.submit': 'Create Account',
  'auth.register.hasAccount': 'Already have an account?',
  'auth.register.loginLink': 'Sign in',
  'auth.register.success': 'Welcome to Rx.K Seoul!',
  'auth.register.error': 'Registration failed. Please try again.',
  'auth.forgot.title': 'Reset Password',
  'auth.forgot.subtitle': 'Enter your email and we will send you instructions',
  'auth.forgot.email': 'Email',
  'auth.forgot.submit': 'Send Reset Link',
  'auth.forgot.sent': 'If an account exists, a reset link has been sent.',
  'auth.forgot.backToLogin': 'Back to Sign In',

  // ===== MY PAGE =====
  'my.dashboard': 'Dashboard',
  'my.joinDate': 'Member since',
  'my.grade': 'Grade',
  'my.mileageBalance': 'Mileage',
  'my.logout': 'Sign Out',
  'my.recentOrders': 'Recent Orders',
  'my.orderDetail': 'Order Detail',
  'my.pending': 'Pending',
  'my.tracking': 'Tracking',
  'my.reorder': 'Reorder',
  'my.profile.title': 'Profile Settings',
  'my.profile.info': 'Personal Information',
  'my.profile.language': 'Language',
  'my.profile.saved': 'Profile updated',
  'my.profile.password': 'Change Password',
  'my.profile.currentPassword': 'Current Password',
  'my.profile.newPassword': 'New Password',
  'my.profile.confirmNewPassword': 'Confirm New Password',
  'my.profile.changePassword': 'Update Password',
  'my.profile.passwordChanged': 'Password updated (mock)',
  'my.orders.title': 'Orders',
  'my.orders.empty': 'No orders yet',
  'my.mileage.title': 'Mileage',
  'my.mileage.balance': 'Current Balance',
  'my.mileage.history': 'Transaction History',
  'my.mileage.empty': 'No transactions yet',
  'my.mileage.expires': 'Expires',
  'my.mileage.earn': 'Earned',
  'my.mileage.use': 'Used',
  'my.mileage.expire': 'Expired',
  'my.mileage.adjust': 'Adjusted',
  'my.mileage.policy1.title': '10% Purchase Reward',
  'my.mileage.policy1.desc': 'Earn 10% mileage on every purchase',
  'my.mileage.policy2.title': 'Review Reward',
  'my.mileage.policy2.desc': 'Get bonus mileage for product reviews',
  'my.mileage.policy3.title': 'Birthday Coupon',
  'my.mileage.policy3.desc': 'Special birthday mileage gift every year',
  'my.qna.title': 'Q&A',
  'my.qna.empty': 'No questions yet',
  'my.qna.answered': 'Answered',
  'my.qna.pending': 'Pending',
  'my.qna.formHint': 'Have a new question? Contact us directly for faster support.',

  // ===== PARTNER APPLY =====
  'partnerApply.hero.label': 'Partners',
  'partnerApply.hero.heading': 'Become a Rx.K Seoul Partner',
  'partnerApply.hero.subtitle': 'Join our authorized retail network and bring pharmacist-recommended K-Beauty to your customers.',
  'partnerApply.form.businessName': 'Business Name',
  'partnerApply.form.businessType': 'Business Type',
  'partnerApply.form.typePharmacy': 'Pharmacy',
  'partnerApply.form.typeBeauty': 'Beauty Retail',
  'partnerApply.form.typeOnline': 'Online Store',
  'partnerApply.form.typeDistributor': 'Distributor',
  'partnerApply.form.contactPerson': 'Contact Person',
  'partnerApply.form.email': 'Email',
  'partnerApply.form.phone': 'Phone',
  'partnerApply.form.address': 'Business Address',
  'partnerApply.form.mapLink': 'Google Maps Link (optional)',
  'partnerApply.form.mapLinkHint': 'Search your business on Google Maps, tap Share, and paste the link',
  'partnerApply.form.drugLicenseNo': 'Drug License Number',
  'partnerApply.form.tinNo': 'TIN Number',
  'partnerApply.form.nidNo': 'NID Number',
  'partnerApply.form.binNo': 'BIN Number (optional)',
  'partnerApply.form.city': 'City',
  'partnerApply.form.cityDhaka': 'Dhaka',
  'partnerApply.form.cityChittagong': 'Chittagong',
  'partnerApply.form.citySylhet': 'Sylhet',
  'partnerApply.form.cityOthers': 'Others',
  'partnerApply.form.volume': 'Monthly Volume Estimate',
  'partnerApply.form.volume1': '< 100 units',
  'partnerApply.form.volume2': '100–500 units',
  'partnerApply.form.volume3': '500–1000 units',
  'partnerApply.form.volume4': '1000+ units',
  'partnerApply.form.whyPartner': 'Why partner with us?',
  'partnerApply.form.whyPlaceholder': 'Tell us about your business and why you want to partner (optional)',
  'partnerApply.form.documentsTitle': 'Required Documents',
  'partnerApply.form.docDrugLicense': 'Drug License',
  'partnerApply.form.docTin': 'TIN Certificate',
  'partnerApply.form.docNid': 'NID',
  'partnerApply.form.docPhoto': "Applicant's Photo",
  'partnerApply.form.docBin': 'BIN Certificate (optional)',
  'partnerApply.form.docBankSolvency': 'Bank Solvency Certificate (optional)',
  'partnerApply.form.docBankStatement': '6-Month Bank Statement (optional)',
  'partnerApply.form.chooseFile': 'Choose file',
  'partnerApply.form.submit': 'Submit Application',
  'partnerApply.benefits.title': 'Benefits of Partnering',
  'partnerApply.benefits.brandSupport': 'Official brand support & marketing materials',
  'partnerApply.benefits.training': 'Product training provided by our team',
  'partnerApply.benefits.exclusive': 'Exclusive territory protection',
  'partnerApply.benefits.margin': 'Competitive wholesale margins',
  'partnerApply.success.title': 'Application Submitted',
  'partnerApply.success.body': 'Thank you for your interest. Our partnership team will review your application and contact you within 3 business days.',
  'partnerApply.success.back': 'Back to Where to Buy',

  // ===== HOME (new design) =====
  'homeV2.hero.tile1Label': 'গিফট সেট',
  'homeV2.hero.tile1Title': '{{amount}} সাশ্রয়',
  'homeV2.hero.tile2Label': '১০০% আসল',
  'homeV2.hero.tile2Title': 'স্ক্যান করে যাচাই করুন',
  'homeV2.shop.byCategory': 'ক্যাটাগরি অনুযায়ী',
  'homeV2.shop.bySkin': 'স্কিন টাইপ অনুযায়ী',
  'homeV2.sbar.giftBox': 'গিফট বক্স',
  'homeV2.sbar.save': 'সাশ্রয়',
  'homeV2.sbar.add': 'কার্টে যোগ করুন',
  'v2h.category': 'ক্যাটাগরি',
  'v2h.concern': 'ত্বকের সমস্যা',
  'v2h.ritual': '৩-ধাপের রুটিন',
  'v2h.giftSet': 'গিফট সেট',
  'v2h.saveOnSet': '৩-স্টেপ সেটে {{amount}} সাশ্রয়',
  'v2h.shopNow': 'এখনই কিনুন',
  'v2h.search': 'খুঁজুন',
  'v2h.wishlist': 'উইশলিস্ট',
  'v2h.account': 'অ্যাকাউন্ট',
  'v2h.searchPlaceholder': 'প্রোডাক্ট, উপাদান বা ত্বকের সমস্যা খুঁজুন',
  'v2h.closeSearch': 'খোঁজা বন্ধ করুন',
  'v2h.results': '{{count}}টি ফলাফল',
  'v2h.popular': 'জনপ্রিয় প্রোডাক্ট',
  'v2h.noResults': 'কোনো প্রোডাক্ট পাওয়া যায়নি। “serum” বা “dark spots” লিখে দেখুন।',
  'v2h.closeMenu': 'মেনু বন্ধ করুন',
  'v2h.verify': 'আপনার প্রোডাক্ট যাচাই করুন',
  'v2h.signIn': 'সাইন ইন',
  'wishlist.title': 'উইশলিস্ট',
  'wishlist.lede': 'আপনার সেভ করা প্রোডাক্ট, যখন খুশি কিনুন।',
  'wishlist.kicker': 'আপনার উইশলিস্ট',
  'wishlist.heading': 'পরে কেনার জন্য',
  'wishlist.headingEm': 'সেভ করা',
  'wishlist.addAll': 'সব কার্টে যোগ করুন',
  'wishlist.addedAll': 'সেভ করা সব প্রোডাক্ট কার্টে যোগ হয়েছে',
  'wishlist.saved': 'উইশলিস্টে সেভ হয়েছে',
  'wishlist.removed': 'উইশলিস্ট থেকে সরানো হয়েছে',
  'wishlist.emptyTitle': 'এখনো কিছু সেভ করা হয়নি',
  'wishlist.emptyText': 'যেকোনো প্রোডাক্টের হার্ট চাপুন, সেটা এখানে থেকে যাবে।',
  'wishlist.shop': 'প্রোডাক্ট দেখুন',
  'wishlist.guestNote': 'এই ডিভাইসে সেভ করা আছে।',
  'wishlist.signIn': 'সব ডিভাইসে রাখতে সাইন ইন করুন।',
  'wishlist.moreKicker': 'আপনার আরও ভালো লাগতে পারে',
  'wishlist.more': 'রুটিনটা',
  'wishlist.moreEm': 'সম্পূর্ণ করুন',
  'cartV2.title': 'আপনার ব্যাগ',
  'cartV2.giftBox': 'গিফট বক্স · ৩ ধাপ',
  'cartV2.emptyTitle': 'আপনার ব্যাগ খালি',
  'cartV2.emptyText': '৩-ধাপের রুটিন দিয়ে শুরু করুন, অথবা আপনার ত্বকের যে ধাপটা সবচেয়ে দরকার সেটা বেছে নিন।',
  'cartV2.shop': 'প্রোডাক্ট দেখুন',
  'cartV2.awayPre': 'ফ্রি ডেলিভারি থেকে আর',
  'cartV2.awayPost': 'বাকি',
  'cartV2.free': 'আপনার অর্ডারে ডেলিভারি ফ্রি',
  'cartV2.offerKicker': 'রুটিন সম্পূর্ণ করুন',
  'cartV2.save': 'সাশ্রয়',
  'cartV2.add': 'যোগ করুন',
  'cartV2.delivery': 'ডেলিভারি ঢাকায় ৳৭০, ঢাকার বাইরে ৳১২০ · ৳৩,০০০-এর বেশি হলে ফ্রি। চেকআউটে হিসাব হবে।',
  'cartV2.cod': 'ক্যাশ অন ডেলিভারি',
  'homeV2.shop.byConcern': 'সমস্যা অনুযায়ী',
  'homeV2.shop.concern.dull': 'নিষ্প্রভ ত্বক',
  'homeV2.shop.concern.spots': 'কালো দাগ',
  'homeV2.shop.concern.dry': 'শুষ্ক ত্বক',
  'homeV2.shop.concern.oily': 'তৈলাক্ত ত্বক',
  'homeV2.shop.concern.sens': 'সংবেদনশীল',
  'homeV2.shop.concernLong.dull': 'নিষ্প্রভ ও ক্লান্ত',
  'homeV2.shop.concernLong.spots': 'কালো দাগ ও ছোপ',
  'homeV2.shop.concernLong.dry': 'শুষ্ক ও টানটান',
  'homeV2.shop.concernLong.oily': 'তৈলাক্ত ও বড় লোমকূপ',
  'homeV2.shop.concernLong.sens': 'সংবেদনশীল',
  'homeV2.shop.sortNew': 'নতুন আগে',
  'homeV2.shop.all': 'সব',
  'homeV2.shop.allProducts': 'সব প্রোডাক্ট',
  'homeV2.shop.catSet': 'সেট',
  'homeV2.shop.catEssence': 'টোনার ও এসেন্স',
  'homeV2.shop.catSerum': 'সিরাম',
  'homeV2.shop.catCream': 'ময়েশ্চারাইজার',
  'homeV2.shop.categoryHeading': 'ক্যাটাগরি',
  'homeV2.shop.product': 'টি প্রোডাক্ট',
  'homeV2.shop.products': 'টি প্রোডাক্ট',
  'homeV2.shop.sortLabel': 'সাজান:',
  'homeV2.shop.sortFeatured': 'বাছাই করা',
  'homeV2.shop.sortLow': 'দাম: কম থেকে বেশি',
  'homeV2.shop.sortHigh': 'দাম: বেশি থেকে কম',
  'homeV2.shop.sale': 'সেল',
  'homeV2.shop.empty': 'এই ফিল্টারে কোনো প্রোডাক্ট নেই।',
  'homeV2.shop.showAll': 'সব প্রোডাক্ট দেখুন',
  'homeV2.shop.showMore': 'আরও দেখুন',
  'homeV2.ritual.label': 'প্রতিদিনের রুটিন',
  'homeV2.ritual.heading': 'Open · Treat · Lock',
  'homeV2.ritual.headingEm': 'পাঁচ মিনিটেরও কমে',
  'homeV2.ritual.cta': '3-Step সেট কিনুন',
  'homeV2.watch.label': 'দেখুন ও কিনুন',
  'homeV2.watch.heading': 'রুটিনটি দেখুন',
  'homeV2.watch.headingEm': 'হাতে-কলমে',
  'homeV2.watch.full': 'পুরো রুটিন',
  'homeV2.watch.step': 'স্টেপ',
  'homeV2.watch.shopNow': 'এখনই কিনুন',
  'homeV2.brand.kicker': 'সিউল থেকে ঢাকা',
  'homeV2.brand.heading': 'কোরিয়ান ফার্মেসি স্কিনকেয়ার,',
  'homeV2.brand.headingEm': 'বাংলাদেশের জন্য তৈরি।',
  'homeV2.brand.body': 'নিয়ে এসেছে ফার্মাসিস্টদের বাছাই করা কোরিয়ান ফর্মুলা: ক্লিনিক্যাল-গ্রেড উপাদান, সিউলে তৈরি, আমাদের গরম ও আর্দ্র আবহাওয়ার কথা মাথায় রেখে।',
  'homeV2.brand.fact1Title': 'Seoul',
  'homeV2.brand.fact1Body': 'কোরিয়ায় ফর্মুলা ও তৈরি',
  'homeV2.brand.fact2Title': 'Rx',
  'homeV2.brand.fact2Body': 'ফার্মাসিস্ট-প্রস্তাবিত ফর্মুলা',
  'homeV2.brand.fact3Title': 'BSTI',
  'homeV2.brand.fact3Body': 'বাংলাদেশে সার্টিফায়েড',
  'homeV2.brand.fact4Title': '2026',
  'homeV2.brand.fact4Body': 'KOTRA-র সাথে K-Goods Festa-য় লঞ্চ',
  'homeV2.brand.ctaStory': 'আমাদের গল্প পড়ুন',
  'homeV2.brand.ctaWhere': 'কোথায় পাবেন',
  'homeV2.launch.label': 'K-Goods Festa 2026',
  'homeV2.launch.heading': 'যেখানে K-Beauty দেখা পেল',
  'homeV2.launch.headingEm': 'বাংলাদেশের',
  'homeV2.launch.subtitle': 'KOTRA ও কোরিয়া প্রজাতন্ত্রের দূতাবাসের যৌথ আয়োজনে · যমুনা ফিউচার পার্ক · ১৯–২০ জুন ২০২৬',
  'homeV2.launch.cap1': 'Rx.K Testing Zone-এ উপচে পড়া ভিড়',
  'homeV2.launch.cap2': 'VIP কর্নারে সরাসরি পরামর্শ',
  'homeV2.launch.cap3': 'বিজ্ঞানভিত্তিক স্কিনকেয়ার পরামর্শ',
  'homeV2.launch.cap4': '3-Step ডেইলি ট্রিটমেন্টের সাথে পরিচয়',
  'homeV2.launch.cap5': 'The.K Seoul প্যাভিলিয়ন, যমুনা ফিউচার পার্ক',
  'homeV2.verify.kicker': '১০০% আসল হওয়ার গ্যারান্টি',
  'homeV2.verify.heading': 'স্ক্যান। যাচাই।',
  'homeV2.verify.headingEm': 'নিশ্চিন্ত।',
  'homeV2.verify.body': 'প্রতিটি Rx.K Seoul বক্সে আছে নিজস্ব QR কোড আর সিরিয়াল নম্বরসহ সিলভার হলোগ্রাম। দশ সেকেন্ডে যাচাই করুন, সরাসরি কোরিয়ার The.K Seoul Co., Ltd. থেকে।',
  'homeV2.verify.step1': 'বক্সের উপরে সিলভার হলোগ্রামটি খুঁজুন',
  'homeV2.verify.step1Note': 'একটু কাত করুন: ঝিলমিল করবে। নকলে এটা হয় না।',
  'homeV2.verify.step2': 'ফোনের ক্যামেরা দিয়ে QR কোড স্ক্যান করুন',
  'homeV2.verify.step2Note': 'কোনো অ্যাপ লাগবে না',
  'homeV2.verify.step3': 'সবুজ মানে আসল',
  'homeV2.verify.step3Note': 'ব্যাচ, উৎপাদন ও মেয়াদের তারিখ দেখতে পাবেন',
  'homeV2.verify.cta': 'আপনার প্রোডাক্ট যাচাই করুন',
  'homeV2.verify.note': 'DGDA-নিবন্ধিত যাচাই ব্যবস্থা · কোনো সমস্যা মনে হলে কল করুন 09617 66 11 66',
  'homeV2.verify.guide': 'পুরো গাইড দেখুন · ১:৩০',
  'homeV2.verify.holoTitle': 'সিলভার হলোগ্রাম',
  'homeV2.verify.holoNote': '২৭ × ২৮ মিমি · প্রতিটি বক্সের উপরে',
  'homeV2.services.s1Title': 'ক্যাশ অন ডেলিভারি',
  'homeV2.services.s1Body': 'হাতে পেয়ে রাইডারকে টাকা দিন',
  'homeV2.services.s2Title': 'ফ্রি ডেলিভারি',
  'homeV2.services.s2Body': '৳৩,০০০-এর বেশি অর্ডারে',
  'homeV2.services.s3Title': '১০০% আসল',
  'homeV2.services.s3Body': 'প্রতিটি বক্স QR দিয়ে যাচাইযোগ্য',
  'homeV2.services.s4Title': 'ফার্মাসিস্ট-যাচাইকৃত',
  'homeV2.services.s4Body': 'কোরিয়ায় তৈরি · BSTI সার্টিফায়েড',
} as const;